import { configure, makeAutoObservable  } from 'mobx'
import { Page, PhotoElement, LayerGroup, TextStyleToolbar, ContextMenu, Element, TextElement, SVGElement, SVGGroup } from './componentStore'
import HistoryStore from './historyStore'
import { v4 as uuidv4, validate as uuidValidate } from 'uuid'
import historyStore from './historyStore';
import { ReactComponent as TrashIcon } from "../svg/delete-icon.svg";
import { ReactComponent as CopyIcon } from "../svg/copy-icon.svg";
import { ReactComponent as ForwardIcon } from "../svg/bring-forward.svg";
import { ReactComponent as BackwardIcon } from "../svg/send-backward.svg";
import { ReactComponent as FullForward } from "../svg/bring-to-front.svg";
import { ReactComponent as FullBack } from "../svg/send-to-back.svg";
import { ReactComponent as PasteIcon } from "../svg/check-icon.svg";
import { ReactComponent as ObjectGroupIcon } from "../svg/object-group.svg";
import { ReactComponent as SetBgIcon } from '../svg/set-background.svg'
import { ReactComponent as ObjectUnGroupIcon } from "../svg/object-ungroup.svg";
import { rotatePoint, scalePoint, translatePoint, getPoints, rotateAndTranslatePoint, calcAngle } from "../utils/transformations"
import { 
  adminUpdate, attachDesignToBrand, fetchDesign, 
  fetchDesignJSON, 
  getBrands, getPublicDesign, incrementDesignClick, 
  saveBrand, unLinkPublicDesign, updateDesignProperties } from '../services/DesignService';
import { fetchFonts } from '../services/ElementService';
import { parseSvg } from '../utils/svg';

configure({
    enforceActions: "never",
})

class WorkAreaStore {

  constructor(errorStore) {
    makeAutoObservable(this);
    this.errorStore = errorStore
  }

  //Initial page scale is 40%
  scale = 0.4
  zoom = 100
  snapEnabled = false
  editingColor = null
  workAreaSize = null
  pages = []
  guidelines = []
  groups = []
  textStyleToolbars = []
  textShadowUpdate = null
  wait = false
  isKeyboard = false
  movingLayer = false
  resizingLayer = false
  compiled = false
  beingEdited = false
  isSelecting = false
  socialOpen = false
  containerScroll = 0
  fitValue = 0
  canEditTeam = false
  pageCenter = 0
  resizingLayerBar = false
  isPublic = false
  mouseStartX = 0
  mouseStartY = 0
  contextMenu = null
  designId = null
  settingText = false
  groupedGroups = null
  mouseStartResizeX = 0
  cutLayer = null
  initialCrop = {
    x: 0,
    y: 0
  }
  lastTextColor = null
  cutIndex = 0
  cutGroupLayers = null
  mouseStartResizeY = 0
  alignOpen = false
  invalidPermissionsModal = false
  shiftOpen = false
  mouseStartRotateX = 0
  mouseStartRotateY = 0
  saving = false
  resizeElement = {
    topLeft: false,
    topRight: false,
    bottomRight: false,
    bottomLeft: false
  }
  baseTemplate = null
  publicDesignProps = {
    status: '',
    category: '',
    tags: '',
    description: '',
    freeTemplate: true
  }
  backgroundCropper = false
  propsLoading = false
  fontKeyword = ''
  fontFamily = ''
  prevFontIdx = 0
  resizeBarElement = {
    left: false,
    right: false,
    top: false,
    bottom: false
  }
  cropBarElement = {
    left: false,
    right: false,
    top: false,
    bottom: false
  }
  hidden = false
  selectedLayer = null
  rotate = false
  copiedLayer = null
  brands = []
  activeBrand = false
  activePage = null
  loadedFonts = []
  fontsLoading = false
  outofBoundsLayer = null
  moreFonts = true
  fontPage = 0
  fontSelect = false
  pageGrouped = false
  changed = false
  saved = true
  newLayerPage = null
  shared = false
  title = ''
  cursorPicker = false
  cursorColor = null
  cursorX = 0
  cursorY = 0
  editingTextId = null
  zoomOpen = false
  publicPermissions = 'view'
  isOwner = false
  optimalSize = null
  resizingPage = null
  mockupBase = false
  mockup = {}
  mockupMeta = null
  pageResizeDown = false
  draggingBackground = false
  emptySaved = true
  designRoles = []

  setCursorPicker(status){
    this.cursorPicker = status
  }

  setCursorColor(color){
    this.cursorColor = color
  }

  setSaving(status){
    this.saving = status
  }

  setCursorLocation(x, y){
    const zoom = this.zoom / 100
    this.cursorX = (x) + 30
    this.cursorY = (y) + 5
  }

  setEmptySaved(status){
    this.emptySaved = status
  }

  updateDesignPublicProp(name, value){
    this.publicDesignProps[name] = value
  }

  handleBackgroundResizeMouseDown(x, y){
    this.pageResizeDown = true
    this.mouseStartResizeX = x
    this.mouseStartResizeY = y
  }

  setContainerScroll(x){
    this.containerScroll = x
  }

  handleBackgroundMoveMouse(x, y, unset = false){
    if(unset){
      this.draggingBackground = false
      this.mouseStartX = 0
      this.mouseStartY = 0
      return
    }else{
      this.mouseStartX = x
      this.mouseStartY = y
      this.draggingBackground = true
    }
  }

  handleBackgroundResizeMouseUp(){
    this.pageResizeDown = false
    this.mouseStartResizeX = 0
    this.mouseStartResizeY = 0
  }

  resizePageBackground(clientX, clientY){
    const dx = (clientX - this.mouseStartResizeX)
    const dy = (clientY - this.mouseStartResizeY)
    if(!this.resizingPage){
      return
    }
    const page = this.pages.find(({ id }) => id === this.resizingPage)
    if(!page){
      return
    }
    const { backgroundHeight, backgroundWidth, backgroundPosition: { x, y } } = page
    const { bottomLeft, bottomRight, topLeft, topRight } = this.resizeElement
    const { xPosNew, yPosNew, newHeight, newWidth } = this.calculateBackgroundImageDimensions(backgroundHeight, backgroundWidth, x, y, clientX, clientY)
    const pageElement = document.querySelector(`.workarea__page[data-id="${btoa(page.id)}"]`)
    const cropperElement = document.querySelector(`.workarea__page__cropper[data-id="${btoa(page.id)}"]`)
    const { y: cropperY, x: cropperX, height: cropperH, width: cropperW } = cropperElement.getBoundingClientRect()
    const { y: pageY, x: pageX, height: ph, width: pw } = pageElement.getBoundingClientRect()
    const lockTopY = (topLeft || topRight) && (cropperY + dy) > pageY
    const lockBottomY = (bottomRight || bottomLeft) && (cropperY + cropperH + dy) < pageY + ph
    const lockLeftX = (topLeft || bottomLeft) && (cropperX + dx) > pageX
    const lockRightX = (topRight || bottomRight) && (cropperX + cropperW + dx) < pageX + pw
    if(!lockTopY && !lockBottomY && !lockLeftX && !lockRightX){
      page.backgroundPosition.x = xPosNew
      page.backgroundWidth = newWidth
      page.backgroundHeight = newHeight
      page.backgroundPosition.y = yPosNew
    }
    this.mouseStartResizeX = clientX
    this.mouseStartResizeY = clientY
    return false
  }

  getBackgroundLock(page, dx, dy){
    const pageElement = document.querySelector(`.workarea__page[data-id="${btoa(page.id)}"]`)
    const cropperElement = document.querySelector(`.workarea__page__cropper[data-id="${btoa(page.id)}"]`)
    const { y: pageY, x: pageX, height, width } = pageElement.getBoundingClientRect()
    const { y: cropperY, x: cropperX, height: cropperH, width: cropperW } = cropperElement.getBoundingClientRect()
    const lockYTop = (cropperY + dy) > pageY
    const lockYBottom = (cropperY + cropperH + dy) < pageY + height
    const lockLeftX = (cropperX + dx) > pageX
    const lockRightX = (cropperX + cropperW + dx) < pageX + width
    return { lockLeftX, lockRightX, lockYTop, lockYBottom }
  }

  async incrementClick(id){
    try{
      this.baseTemplate = null
      await incrementDesignClick(id, this.designId)
    }catch(err){
      console.log(err)
    }
  }

  async handlePublicUnlink(){
    try{
      this.baseTemplate = null
      await unLinkPublicDesign(this.designId)
    }catch(err){
      console.log(err)
    }
  }

  movePageBackground(x, y){
    const idx = this.pages.findIndex(({ id }) => id === this.resizingPage)
    if(idx === -1){
      return
    }
    const page = this.pages[idx]
    const { x: px, y: py } = page.backgroundPosition
    const zoom = this.zoom / 100
    const dx = (x - this.mouseStartX) / zoom
    const dy = (y - this.mouseStartY) / zoom
    const xPos = px + dx
    const yPos = py + dy
    const { lockLeftX, lockRightX, lockYTop, lockYBottom } = this.getBackgroundLock(page, dx * zoom, dy * zoom)
    if(!lockYBottom && !lockYTop){
      this.pages[idx].backgroundPosition.y = yPos
    }
    if(!lockLeftX && !lockRightX){
      this.pages[idx].backgroundPosition.x = xPos
    }
    this.mouseStartY = y
    this.mouseStartX = x
  }

  toggleBackgroundCropper(pageId, init = false){
    const idx = this.pages.findIndex(({ id }) => id === pageId)
    if(idx > -1 && this.pages[idx] && this.pages[idx].backgroundUrl){
      const val = !this.pages[idx].cropperOpen
      if(val){
        this.resizingPage = this.pages[idx].id
      }else{
        this.resizingPage = null
      }
      if(val){
        this.initialCrop = {...this.pages[idx].backgroundPosition}
      }
      if(!val && init){
        this.pages[idx].backgroundPosition = this.initialCrop
      }
      if(!val && !init){
        this.setChanged(true)
      }
      this.pages[idx].cropperOpen = val
    }
  }

  getPageBackgroundFullStyle(pageId){
    const page = this.pages.find(({ id }) => id === pageId)
    const idx = this.pages.findIndex(({ id }) => id === pageId)
    const backgroundProps = {
      width: 0,
      height: 0,
    }
    if(!page){
      return backgroundProps
    }
    const { displayWidth, displayHeight, backgroundHeight, backgroundWidth, backgroundPosition } = page
    if(!backgroundPosition){
      page.backgroundPosition = {
        x: (displayWidth - backgroundWidth) / 2,
        y: -20 * (idx + 1)
      }
    }
    backgroundProps.transform = `translate(${page.backgroundPosition.x}px, ${page.backgroundPosition.y}px)`
    backgroundProps.height = backgroundHeight
    backgroundProps.width = backgroundWidth
    return backgroundProps
  }

  setActiveBackgroundCropper(type){
    Object.keys(this.cropBarElement).forEach(key => {
      if(key === type && !this.cropBarElement[key]){
        this.cropBarElement[key] = true
      }else{
        this.cropBarElement[key] = false
      }
    })
  }

  async updatePublicProps(){
    try{
      this.propsLoading = true
      const res = await adminUpdate({ ...this.publicDesignProps, title: this.title, publicId: this.designId })
    }catch(err){
      console.log(err)
      this.errorStore.setErrorMessage('Failed to update design', true)
    }finally {
      this.propsLoading = false
    }
  }

  checkScroll(){
    const container = document.querySelector('.container-fluid.d-flex')
    const root = document.querySelector('#root')
    let scrollVal = 0
    if(root && root.scrollTop !== 0){
      scrollVal = root.scrollTop
      root.scrollTo(0,0)
    }
    if(container && container.scrollTop !== 0){
      scrollVal = container.scrollTop
      container.scrollTo(0,0)
    }
    if(scrollVal){
      const area = document.querySelector('.workarea')
      const { scrollTop, scrollLeft } = area
      area.scrollTo(scrollLeft, scrollTop + scrollVal)
    }
  }

  async populateBrands(){
    const data = await getBrands(this.designId)
    this.brands = data.brands
    this.activeBrand = data.activeBrand
  }

  setZoomOpen(value){
    this.zoomOpen = value
  }

  async attachToBrand(projectId){
    const data = await attachDesignToBrand(this.designId, projectId)
    this.brands = data.brands
    this.activeBrand = data.activeBrand
  }

  async createNewBrand(name){
    const data = await saveBrand(name, this.designId)
    this.brands = data.brands
    this.activeBrand = data.activeBrand
  }

  setHidden(status){
    this.hidden = status
  }

  getFilters(obj){
    let base = {
      opacity: 100,
      brightness: 100,
      contrast: 100,
      saturation: 100,
      blur: 0
    }
    if(!obj){
      return base
    }
    if(obj && obj.length){
      obj.forEach(filter => {
        if(filter && filter.type){
          const key = filter.type.toLowerCase()
          let val = Number('1' + String(Math.abs(filter[key] * 100)))
          if(filter[key] < 0){
            val = filter[key] * 100 + 100
          }
          base[key] = val
        }
      })
    }
    if(obj && !obj.length){
      base = obj
    }
    return base
  }

  getCorrectLayerType(layer){
    const { 
      id,
      dataSource,
      position,
      scale,
      type,
      displayHeight,
      displayWidth,
      groupId
    } = layer
    switch(type){
      case 'svgGroup':
        return new SVGGroup(
          id,
          dataSource,
          displayHeight,
          displayWidth,
          layer.frameHeight,
          layer.frameWidth,
          layer.boxH,
          layer.boxW,
          layer.boxX,
          layer.boxY,
          position.xPos,
          position.yPos,
          isNaN(position.xCrop) ? 0 : position.xCrop,
          isNaN(position.yCrop) ? 0 : position.yCrop,
          layer.assetColors,
          null,
          layer.locked,
          layer.position.rotation,
          layer.finalGroup
        )
      case 'photo':
        return new PhotoElement(
          id,
          dataSource,
          displayHeight,
          displayWidth,
          displayHeight,
          displayWidth,
          position.yPos,
          position.xPos,
          scale,
          position.xCrop,
          position.yCrop,
          layer.frameWidth,
          layer.frameHeight,
          position.rotation,
          displayHeight,
          displayWidth,
          groupId,
          layer.photoType ? layer.photoType : null,
          layer.frames ? layer.frames : null,
          this.getFilters(layer.filters),
          layer.isUpload,
          layer.assetId,
          layer.locked || false
        )
      case 'group':
        return new LayerGroup(
          id,
          displayHeight,
          displayWidth,
          displayHeight,
          displayWidth,
          displayHeight,
          displayWidth,
          displayWidth,
          displayHeight,
          position.xPos,
          position.yPos,
          0,
          0,
          scale,
          position.rotation,
          layer.layers,
          layer.finalGroup,
          layer.locked || false
        )
      case 'element':
        let objectsPrefix = '/objects';
        if(process.env.REACT_APP_NODE_ENV !== 'development') {
          objectsPrefix = '/design-editor/objects';
        }

        layer.dataSource = `${objectsPrefix}/${layer.name}`

        const stretchScale = {
          x: 1,
          y: 1,
          z: 1
        }
        return new Element(
          id,
          layer.dataSource,
          layer.height || 100,
          layer.width || 100,
          displayHeight,
          displayWidth,
          displayHeight,
          displayWidth,
          position.yPos,
          position.xPos,
          layer.xCrop,
          layer.yCrop,
          layer.opacity || 1,
          scale,
          layer.fillHex || '#222222',
          position.rotation,
          groupId,
          null,
          layer.name,
          layer.stretchScale || stretchScale,
          position.originX || 'left',
          position.originY || 'top',
          layer.locked || false
        )
      case 'text':
        const toolbar = new TextStyleToolbar(id)
        this.textStyleToolbars.push(toolbar)
        const {
          colors,
          content,
          fontFamily,
          fontSize,
          italic,
          opacity,
          spacing,
          underline,
          lineHeight,
          weight,
          textAlign,
          textShadow
         } = layer.properties
        return new TextElement(
          id,
          content, 
          textShadow ? textShadow : {
            x: 0,
            y: 0,
            color: '#000',
            display: false
          },
          fontSize,
          position.xPos,
          position.yPos,
          fontFamily,
          colors,
          weight,
          scale,
          position.rotation,
          displayWidth,
          displayHeight,
          displayHeight,
          displayWidth,
          displayHeight,
          displayWidth,
          layer.frameHeight,
          layer.frameWidth,
          position.xCrop,
          position.yCrop,
          lineHeight || 1.4,
          spacing,
          opacity,
          italic,
          underline,
          groupId,
          position.editorHeight,
          position.editorWidth,
          false,
          textAlign,
          layer.locked || false
        )
      default:
        break
    }
  }

  toggleFontSelect(state = false){
    this.fontSelect = state
  }

  togglePageTools(pageId, status){
    const page = this.pages.find(({ id }) => id === pageId)
    if(page){
      page.toolsOpen = status
    }
  }

  setFontFamily(family){
    this.fontFamily = family
    this.prevFontIdx = 0
  }

  async getFonts(keyword, reset = false){
    this.fontsLoading = true
    if(reset){
      this.fontPage = 0
      this.prevFontIdx = 0
      this.loadedFonts = []
      this.moreFonts = true
    }
    if(!this.moreFonts && !reset && keyword === this.fontKeyword){
      this.fontsLoading = false
      return
    }
    if(this.fontKeyword !== keyword && keyword.length){
      this.loadedFonts = []
      this.moreFonts = true
    }
    this.fontKeyword = keyword
    try{
      const data = await fetchFonts(this.fontPage, this.fontKeyword, this.fontFamily, this.prevFontIdx)
      data.fonts.forEach(f => {
        if(f){
          this.loadedFonts.push(f)
        }
      })
      if(data.isMore){
        this.fontPage = this.fontPage + 1
      }else{
        this.moreFonts = false
      }
      if(this.fontFamily && this.fontFamily.length){
        this.prevFontIdx = data.fonts.length ? data.fonts[data.fonts.length - 1].index : 0
      }
    }catch(e){
      this.fontsLoading = false
      this.moreFonts = false
      this.errorStore.setErrorMessage('Could not load fonts', true)
    }finally {
      this.fontsLoading = false
    }
  }

  addNewPage(pageIdx){
    const { height, width, displayHeight, displayWidth, title } = this.pages[0]
    const newPage = new Page(
      height,
      width,
      displayHeight,
      displayWidth,
      '#FFFFFF',
      [],
      uuidv4(),
      false,
      title,
      false,
      '',
      undefined,
      false,
      null,
      null,
      false,
      {
        x: 0,
        y: 0
      },
      {
        opacity: 100,
        brightness: 100,
        contrast: 100,
        saturation: 100,
        blur: 0
      },
    )
    this.pages.splice(pageIdx + 1, 0, newPage)
    this.appendToHistory()
    setTimeout(() => {
      this.scrollToPage(newPage.id, true)
    }, 50)
  }

  setChanged(status, statusUpdate = true){
    this.hideUpload()
    this.changed = status
    if(status && statusUpdate){
      this.saved = false
    }
    const t = document.querySelector('#design-editor-title')
    if(t){
      t.textContent = this.title + ' | Mediamodifier Design Editor'
    }
  }

  setSaved(status){
    this.saved = status
  }

  refreshText(newId, pageIdx, layerIdx, editing){
    const {
      content,
      size,
      xPos,
      yPos,
      font,
      colors,
      weight,
      scale,
      rotation,
      width,
      height,
      displayHeight,
      displayWidth,
      originalDisplayHeight,
      originalDisplayWidth,
      frameHeight,
      frameWidth,
      xCrop,
      yCrop,
      lineHeight,
      spacing,
      opacity,
      italic,
      underline,
      groupId,
      editorHeight,
      editorWidth,
      textShadow,
      alignment,
      textAlign,
      selected
    } = this.pages[pageIdx].layers[layerIdx]
    const textElem = new TextElement(
      newId,
      content,
      textShadow ? textShadow : { x: 0, y: 0, display: false, color: '#000' },
      size,
      xPos,
      yPos,
      font,
      colors,
      weight,
      scale,
      rotation,
      width,
      height,
      displayHeight,
      displayWidth,
      originalDisplayHeight,
      originalDisplayWidth,
      frameHeight,
      frameWidth,
      xCrop,
      yCrop,
      lineHeight,
      spacing,
      opacity,
      italic,
      underline,
      groupId,
      editorHeight,
      editorWidth,
      editing,
      textAlign,
      false,
      alignment,
      selected
    )
    this.pages[pageIdx].layers.splice(
      layerIdx,
      1,
      textElem
    )
  }

  //Convert number into hex string
  componentToHex(c) {
    const num = Number(c)
    var hex = num.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  }

  rgbToHex(val){
    const color = val.replace('rgba(', '').replace(')', '').replace('rgb(')
    const [r, g, b, a] = color.split(', ')
    let hex = '#'
    if(a && a.length){
      const aVal = Math.round(a * 100) / 100;
      var alpha = Math.round(aVal * 255);
      var hexAlpha = (alpha + 0x10000).toString(16).substr(-2).toUpperCase();
      hex += hexAlpha
    }
    hex += this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b)
    return hex
  }

  hexToRgba(val){
    // Remove hash
    var hex = val.slice(1);
    
    // Split to four channels
    var c = hex.match(/.{1,2}/g);
    
    // Function: to decimals (for RGB)
    var d = function(v) {
        return parseInt(v, 16);
    };
    // Function: to percentage (for alpha), to 3 decimals
    var p = function(v) {
        return parseFloat(parseInt((parseInt(v, 16)/255)*1000)/1000);
    };
    
    // Check format: if it's argb, pop the alpha value from the end and move it to front
    var a, rgb=[];
    // Convert array into rgba values
    a = p(c[3]);
    c.forEach((val, idx) => { if(idx === c.length - 1 && c.length === 4){rgb.push(d(val)/255)}else{rgb.push(d(val))}})
    const converted = `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${c.length === 4 ? rgb[3] : '1'})`
    return converted
  }

  updateTextLayer(layer){
    if(!layer){
      return null
    }
    const selector = `.workarea-tools__text-layer.${btoa(layer.id)} p`
    const parentElements = document.querySelectorAll(selector)
    if(!parentElements.length){
      return
    }
    const copy = { ...layer }
    copy.colors = []
    let prevStart = 0
    let copyContent = ''
    copy.content = ''
    let set = false
    parentElements.forEach((parent, idx) => {
      parent.childNodes.forEach((child, childIdx) => {
        //If the cursor is set at the beginning of the text layer
        if(child.querySelector('.ql-cursor') && copy.content === ''){
          return
        }
        //If there is more than 1 P element OR the cursor is set at a new line
        if((idx > 0 && childIdx === 0) || (child.querySelector('.ql-cursor'))){
          const last = copy.colors[copy.colors.length - 1]
          if(last && copy.content.trim().length > 0){
            copyContent += '\n'
            last.deltaEnd += 1
            prevStart += 1
            set = true
          }
        }
        const childTextContent = child.innerText
        const nodename = child.nodeName
        //If there is a breakline at the start of the text
        if(nodename === 'BR' && copy.content.trim().length === 0){
          copyContent = ''
          prevStart = 0
          return
        }
        //After the breaklines are rendered have to check if there are breaklines when the text component mounts again
        if(idx === 0 && !set && childTextContent === '\n'){
          copyContent += '\n'
          const last = copy.colors[copy.colors.length - 1]
          if(last){
            last.deltaEnd += 1
            prevStart += 1
          }
          return
        }
        copyContent += childTextContent
        let end = (childTextContent.length - 1) + prevStart
        let hexColor = '#222222'
        if(nodename === 'SPAN' || nodename === 'STRONG' || nodename === 'EM' || nodename === 'U'){
          const shadowVal = child.style.textShadow
          child.style.textShadow = 'none'
          const styleAttr = child.getAttribute('style')
          const regexp = /\(([^)]+)\)/
          const matches = regexp.exec(styleAttr)
          if(matches && matches.length){
            const colorAttribute = matches[1]
            hexColor = this.rgbToHex(colorAttribute)
          }
          child.style.textShadow = shadowVal
        }
        copy.color = hexColor
        copy.colors.push({
          color: hexColor,
          deltaStart: prevStart,
          deltaEnd: end
        })
        prevStart = end + 1
      })
      copy.content += copyContent
      copyContent = ''
    })
    copy.content = copy.content.trim()
    return copy
  }

  setTextEditing(id, status, pageIndex, layerIndex){
    this.settingText = true
    let pageIdx = pageIndex
    let layerIdx = layerIndex
    if(!pageIndex || !layerIndex){
      const { pageIdx: p, layerIdx: l } = this.findLayerIdx(id)
      pageIdx = p
      layerIdx = l
    }
    if(layerIdx > -1){
      this.checkScroll()
      const layer = this.pages[pageIdx].layers[layerIdx]
      const updated = this.updateTextLayer(layer)
      this.pages[pageIdx].layers[layerIdx] = { ...updated, editing: status }
      const slideIdx = this.textStyleToolbars.findIndex(({ id: tid }) => tid === id)
      const newId = uuidv4()
      this.textStyleToolbars.push(new TextStyleToolbar(newId))
      this.refreshText(newId, pageIdx, layerIdx, status)
      this.editingTextId = newId
      this.selectLayer(newId)
      this.textStyleToolbars.splice(slideIdx, 1)
    }
  }

  unsetTextMount(){
    this.settingText = false
  }

  findEditingText(){
    if(this.editingTextId){
      const { pageIdx, layerIdx } = this.findLayerIdx(this.editingTextId)
      if(pageIdx === -1 || !layerIdx){
        return null
      }
      return this.pages[pageIdx].layers[layerIdx]
    }
    return null
  }

  unsetAllEditingText(pageIndex, layerIndex){
    if(this.editingTextId){
      this.setTextEditing(this.editingTextId, false, pageIndex, layerIndex)
      this.editingTextId = null
      this.checkScroll()
      return true
    }
    return false
  }

  deletePageById(pageId){
    this.appendToHistory()
    const pageIdx = this.pages.findIndex(({ id }) => id === pageId)
    const page = this.pages[pageIdx]
    if(!page || this.pages.length === 1){
      return
    }
    page.layers.forEach(l => {
      if(l.type === 'group'){
        this.groups = this.groups.filter(({ id }) => id !== l.id)
      }
      if(l.type === 'text'){
        this.textStyleToolbars = this.textStyleToolbars.filter(({ id }) => id !== l.id)
      }
    })
    this.selectedLayer = null
    this.pages.splice(pageIdx, 1)
    this.appendToHistory()
  }

  getPageLayers(index){
    return this.pages[index].layers
  }

  getPageGuidelines(index) {
    const guides = this.guidelines.find(
      (f) => f.pageId === this.pages[index].id
    )
    if (guides) {
      return { x: guides.x, y: guides.y, id: guides.id }
    } else {
      return []
    }
  }

  deletePageBackground(){
    const page = this.pages.find(({ id }) => id === this.activePage)
    page.filters = {
      opacity: 100,
      brightness: 100,
      contrast: 100,
      saturation: 100,
      blur: 0
    }
    page.backgroundUrl = ''
    page.backgroundId = null
  }

  setTitle(title){
    this.title = title
    this.pages.forEach(p => {
      p.title = title
    })
  }

  resizeGroupByLayers(groupId){
    const allLayers = this.getAllLayers()
    const groupLayer = allLayers.find(({ id }) => id === groupId)
    const groupLayers = allLayers.filter(({ id }) => groupLayer.layers.includes(id))
    const { groupHeight, groupWidth, xPos, yPos } = this.calculateGroupDimensions(groupLayers)
    groupLayer.height = groupHeight
    groupLayer.width = groupWidth
    groupLayer.xPos = xPos
    groupLayer.yPos = yPos
    groupLayer.displayHeight = groupHeight
    groupLayer.displayWidth = groupWidth
    groupLayer.originalDisplayHeight = groupHeight
    groupLayer.originalDisplayWidth = groupWidth
    groupLayer.frameHeight = groupHeight
    groupLayer.frameWidth = groupWidth
  }
  
  async compileDesign(designObject, onlyPages = false){
    const toSet = []
    const pages = designObject.pages.map((page, idx) => {
      const layers = page.layers.map(layer => this.getCorrectLayerType(layer))
      if(page.backgroundUrl && !page.backgroundPosition){
        toSet.push(page)
      }
      const { backgroundWidth, backgroundHeight, backgroundPosition } = page
      return new Page(
        page.height,
        page.width,
        page.displayHeight,
        page.displayWidth,
        page.background,
        layers,
        page.id,
        idx === 0,
        page.title,
        page.transparent,
        page.backgroundUrl,
        page.backgroundId,
        false,
        page.backgroundWidth ? backgroundWidth : page.displayWidth,
        page.backgroundHeight ? backgroundHeight : page.displayHeight,
        false,
        page.backgroundPosition ? backgroundPosition : { x: 0, y: 0 },
        page.filters ? page.filters : 
        {
          opacity: 100,
          brightness: 100,
          contrast: 100,
          saturation: 100,
          blur: 0
        },
      )
    })
    this.title = designObject.title || 'new design'
    const t = document.querySelector('#design-editor-title')
    if(t){
      t.textContent = this.title + ' | Mediamodifier Design Editor'
    }
    this.pages = pages
    const allLayers = this.getAllLayers()
    allLayers.forEach(layer => {
      if(layer.type === 'group'){
        this.resizeGroupByLayers(layer.id)
        this.groups.push(layer)
      }
    })
    this.appendFonts()
    if(!onlyPages){
      this.shared = designObject.shared
      this.designRoles = designObject.roles.map(role => role.role)
      this.publicPermissions = designObject.publicPermissions
      this.isOwner = designObject.isOwner
    }
    this.calculateZoomForScreen()
    toSet.forEach(p => {
      const { pageIdx } = this.pages.findIndex(({ id }) => id === p.id)
      if(pageIdx > -1 && this.pages[pageIdx]){
        this.pages[pageIdx].backgroundId = p.backgroundId
        this.setPageBackgroundSize(p.id, p.backgroundUrl)
      }
    })
  }

  copyPage(pageId){
    const pageIdx = this.pages.findIndex(({ id }) => id === pageId)
    const pageCopy = { ...this.pages[pageIdx], id: uuidv4() }
    pageCopy.layers = pageCopy.layers.map(layer => {
      const layerCopy = {
        ...layer,
        id: uuidv4(),
        selected: false
      }
      if(layer.type === 'group'){
        this.groups.push(layerCopy)
      }
      if(layer.type === 'text'){
        const toolbar = new TextStyleToolbar(layerCopy.id)
        this.textStyleToolbars.push(toolbar)
      }
      return layerCopy
    })
    this.setActivePage(pageCopy.id)
    this.pages.splice(pageIdx + 1, 0, pageCopy)
    this.deleteTextWhitespace()
    //Wait for changes to render in the dom
    setTimeout(() => {
      this.scrollToPage(pageCopy.id, true)
    }, 10)
  }

  scrollToPage(pageId, shiftDown){
    const pageElement = document.querySelector(`[data-id="${btoa(pageId)}"]`)
    const idx = this.pages.findIndex(({ id }) => id == pageId)
    if(pageElement){
      const rect = pageElement.getBoundingClientRect()
      const offset = pageElement.offsetTop
      const { bottom, top } = rect
      const area = document.querySelector('.workarea')
      if(shiftDown){
        const px = (bottom - top + 20) * idx
        setTimeout(() => {
          area.scrollTo(0, px)
        }, 10)
      }else{
        setTimeout(() => {
          if(idx === 0){
            area.scrollTo(0, 0)
          }else{
            area.scrollTo(0, offset - (bottom - top - 20))
          }
        }, 10)
      }
    }
  }

  deleteTextWhitespace(){
    this.pages.forEach(page => {
      page.layers.forEach(layer => {
        if(layer.type === 'text'){
          layer.content = layer.content.trim()
        }
      })
    })
  }

  shiftPage(pageId, shiftDown){
    const pageIdx = this.pages.findIndex(({ id }) => id === pageId)
    const copy = [...this.pages]
    if(shiftDown && pageIdx < this.pages.length - 1){
      copy.splice(pageIdx + 1, 0, copy.splice(pageIdx, 1)[0])
    }
    if(!shiftDown && pageIdx > 0){
      copy.splice(pageIdx - 1, 0, copy.splice(pageIdx, 1)[0])
    }
    this.pages = copy
    this.deleteTextWhitespace()
    this.setActivePage(pageId)
    this.scrollToPage(pageId, shiftDown)
  }

  alignGroupedLayers(alignment, axis, layer, group, prevGroup){
    const { xPos, yPos, displayWidth } = group
    const { xPos: x, yPos: y } = prevGroup
    const pX = Math.round(x)
    const pY = Math.round(y)
    const lX = Math.round(layer.xPos + (layer.xCrop ? layer.xCrop : 0))
    const lY = Math.round(layer.yPos + (layer.yCrop ? layer.yCrop : 0))
    if(axis === 'x'){
      if(lX === pX){
        layer.xPos = xPos - (layer.xCrop ? layer.xCrop : 0)
        return
      }
      const xDiff = (pX - xPos) + (layer.xCrop ? layer.xCrop : 0)
      switch(alignment){
        case 'left':
          if(layer.xPos - xDiff < 0){
            break
          }
          layer.xPos -= (pX - xPos)
          break
        case 'right':
          const xMax = Math.round(displayWidth + xPos)
          if((layer.xPos + layer.displayWidth) + xDiff > xMax){
            break
          }
          layer.xPos -= (pX - xPos)
          break
        case 'center':
          if(Math.round(layer.xPos - xDiff) === Math.round(xPos)){
            break
          }
          layer.xPos -= (pX - xPos)
          break
      }
    }
    if(axis === 'y'){
      if(lY === pY){
        layer.yPos = yPos - (layer.yCrop ? layer.yCrop : 0)
        return
      }
      const diff = (pY - yPos) - layer.yPos - (layer.yCrop ? layer.yCrop : 0)
      switch(alignment){
        case 'top':
          if(layer.yPos - diff < 0){
            break
          }
          layer.yPos -= (pY - yPos)
          break
        case 'bottom':
          if(layer.yPos + diff > yPos){
            break
          }
          layer.yPos -= (pY - yPos)
          break
        case 'middle':
          if(Math.round(layer.yPos - diff) === Math.round(yPos)){
            break
          }
          layer.yPos -= (pY - yPos)
          break
        default:
          break
      }
    }
  }

  setLayerAlignMap(layer, axis, alignment){
    if(!layer.alignMap){
      layer.alignMap = {
        x: {
          left: false,
          right: false,
          center: false
        },
        y: {
          top: false,
          middle: false,
          bottom: false
        }
      }
    }
    if(axis === 'x'){
      Object.keys(layer.alignMap.x).forEach(key => {
        if(key === alignment){
          layer.alignMap.x[key] = true
        }else{
          layer.alignMap.x[key] = false
        }
      })
    }
    if(axis === 'y'){
      Object.keys(layer.alignMap.y).forEach(key => {
        if(key === alignment){
          layer.alignMap.y[key] = true
        }else{
          layer.alignMap.y[key] = false
        }
      })
    }
  }

  alignLayer(alignment, axis){
    const layer = this.getSelectedLayer()
    const page = this.pages.find(({ layers }) => layers.includes(layer))
    if(page && layer){
      const { displayWidth, displayHeight } = page
      const { frameWidth, yCrop, xCrop } = layer
      const copy = { ...layer }
      this.setLayerAlignMap(layer, axis, alignment)
      if(axis === 'x'){
        let w = layer.type === 'element' ? layer.displayWidth : frameWidth
        switch(alignment){
          case 'center':
            let newX = (displayWidth / 2) - (w / 2)
            if(layer.type === 'text'){
              newX = (displayWidth - layer.displayWidth) / 2
              layer.xPos = newX
              break
            }
            if(layer.type === 'photo'){
              layer.xPos = (displayWidth - layer.displayWidth) / 2
              break
            }
            layer.xPos = newX
            break
          case 'left':
            if(layer.type === 'photo'){
              layer.xPos = 0 - xCrop
              break
            }
            layer.xPos = layer.type === 'element' ? 0 : 0 
            break
          case 'right':
            if(layer.type === 'photo'){
              layer.xPos = displayWidth - layer.displayWidth
              break
            }
            layer.xPos = layer.type === 'element' ? displayWidth - w : displayWidth - w
            break
          default:
            break
        }
      }else{
        let h = layer.type === 'element' ? layer.displayHeight : layer.frameHeight
        switch(alignment){
          case 'top':
            if(layer.type === 'photo'){
              layer.yPos = 0 - yCrop
              break
            }
            layer.yPos = 0
            break
          case 'bottom':
            if(layer.type === 'photo'){
              layer.yPos = displayHeight - (layer.displayHeight + layer.yCrop)
              break
            }
            layer.yPos = layer.type === 'element' ? displayHeight - h : displayHeight - layer.frameHeight
            break
          case 'middle':
            if(layer.type === 'element'){
              layer.yPos = (displayHeight - h) / 2
              break
            }
            if(layer.type === 'photo'){
              layer.yPos = (displayHeight / 2 - layer.displayHeight / 2 - yCrop)
              break
            }
            layer.yPos = (displayHeight - layer.displayHeight) / 2
            break
          default:
            break
        }
      }
      if(layer.type === 'group'){
        const layers = this.getAllLayers()
        const groupedLayers = layers.filter(({ id }) => layer.layers.includes(id))
        groupedLayers.forEach(l => {
          this.alignGroupedLayers(alignment, axis, l, layer, copy)
        })
      }
    }
    this.setChanged(true)
    this.appendToHistory()
  }

  appendFont({ id, value }){
    const styleElement = document.createElement('style')
    if(!value){
      return
    }
    const exists = document.querySelector(`[data-id="${btoa(value)}"`)
    if(exists){
      return
    }
    const val = value.split(' ').join('+')
    styleElement.innerText = `@import url('https://fonts.googleapis.com/css2?family=${value}:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900&display=swap')`
    styleElement.setAttribute('data-id', btoa(value))
    styleElement.onload = () => {
      const textLayers = this.getAllLayers().filter(({ type }) => type === 'text')
      textLayers.forEach(l => {
        //Wait for quill changes to migrate in the dom
        setTimeout(() => {
          this.resizeTextLayer(l.id)
        }, 50)
      })
    }
    document.head.appendChild(styleElement)
  }

  setPageBackgroundURL(dataString){
    const page = this.pages.find(({ id }) => id === this.activePage)
    if(!page){
      return
    }
    page.backgroundUrl = dataString
    this.setChanged(true)
  }

  compileDefaultPage(pageId){
    const scaleSize = this.scale
    this.pages.push(
      new Page(1080, 1080, 1080, 1080, '#ffffff', [], pageId, true, 'Blank page', false, '', undefined, false, null, null, false, { x: 0, y: 0 }, {
        opacity: 100,
        brightness: 100,
        contrast: 100,
        saturation: 100,
        blur: 0
      })
    )
    this.calculateZoomForScreen()
    this.appendToHistory()
  }

  async updateDesignPublicPermissions(publicPermissions){
    this.publicPermissions = publicPermissions
    await updateDesignProperties(this.designId, { publicPermissions: this.publicPermissions })
    this.setChanged(true)
  }

  getIdFromPath(){
    const vals = window.location.pathname.split('/')
    let id = vals[vals.length - 1]
    if(!uuidValidate(id)){
      id = vals[vals.length - 2]
    }
    return id
  }

  setNewLocalId(id){
    localStorage.setItem('designId', id)
  }

  async compileLocalDesign(design){
    const id = this.getIdFromPath()
    if(id && uuidValidate(id)){
      const res = await fetchDesign(id)
      if(res.exists && localStorage.getItem('designId') === id){
        const newId = uuidv4()
        this.setNewLocalId(newId)
        const url = `${window.location.origin}/design-editor/${newId}`
        window.location.href = url
        return
      }
      if(res.exists && localStorage.getItem('designId') !== id){
        this.invalidPermissionsModal = true
        return
      }
    }
    if(!id || !uuidValidate(id)){
      const validId = uuidv4()
      this.setNewLocalId(validId)
      const url = `${window.location.origin}/design-editor/${validId}`
      window.location.replace(url)
      return
    }
    if(design && design.id && design.id !== id){
      if(id !== design.id){
        const url = `${window.location.origin}/design-editor/${design.id}`
        window.location.replace(url)
        return
      }
      this.designId = id
    }else{
      if(!design){
        this.designId = id
      }else{
        this.designId = design.id
      }
    }
    if(!design){
      localStorage.removeItem('designId')
      localStorage.removeItem('design')
      localStorage.removeItem('preload')
      const url = `${window.location.origin}/design-editor/${uuidv4()}`
      window.location.replace(url)
    }
    this.createContextMenu()
    const toolbars = []
    design.pages.forEach(p => {
      p.layers.forEach(l => {
        if(l.type === 'text'){
          const lid = uuidv4()
          l.id = lid
          toolbars.push(
            new TextStyleToolbar(lid)
          )
        }
      })
    })
    this.textStyleToolbars = toolbars
    this.pages = design.pages
    this.groups = design.groups
    this.title = design.title
    const layers = this.getAllLayers()
    design.groups.forEach(group => {
      const groupLayers = layers.filter(({ id }) => group.layers.includes(id))
      this.calculateGroupDimensions(groupLayers)
    })
    this.compiled = true
    this.appendFonts()
    this.calculateZoomForScreen()
  }

  createContextMenu(){
    this.contextMenu = new ContextMenu(
      0, 
      0,
      [
        {
          label: 'Delete',
          id: 'delete',
          group: 1,
          disabled: true,
          icon: <TrashIcon />
        },
        {
          label: 'Copy',
          id: 'copy',
          group: 1,
          disabled: true,
          icon: <CopyIcon />
        },
        {
          label: 'Paste',
          id: 'paste',
          group: 1,
          disabled: true,
          icon: <PasteIcon />
        },
        {
          label: 'Bring Forward',
          id: 'front',
          group: 2,
          disabled: true,
          icon: <ForwardIcon />
        },
        {
          label: 'Send Backward',
          id: 'back',
          group: 2,
          disabled: true,
          icon: <BackwardIcon />
        },
        {
          label: 'Bring to front',
          id: 'front-full',
          group: 2,
          disabled: true,
          icon: <FullForward />
        },
        {
          label: 'Send to back',
          id: 'back-full',
          group: 2,
          disabled: true,
          icon: <FullBack />
        }
      ], 
      false
    )
  }

  changePreset(pages){
    this.checkAndCloseCropper()
    this.appendToHistory()
    const design = {
      pages,
      title: this.title
    }
    this.compileDesign(design, true)
    this.appendToHistory()
    this.setChanged(true)
    setTimeout(() => {
      document.querySelector('.full-workarea').style.width = '100%'
      design.pages.forEach((p, pageIdx) => {
        if(pageIdx > -1 && p.backgroundId){
          this.pages[pageIdx].backgroundId = p.backgroundId
          this.setPageBackgroundSize(p.id, p.backgroundUrl)
        }
      })
      this.compiled = true
    }, 1)
  }

  getValidPath(validId){
    const baseArr = window.location.pathname.split('/')
    let idx = baseArr.length - 1
    if(baseArr[idx] === 'view'){
      idx = baseArr.length - 2
    }
    if(baseArr[idx].includes('editor') || baseArr[idx].includes('design')){
      baseArr.push(validId)
    }else{
      baseArr.splice(idx, 1, validId)
    }
    
    return window.location.origin + baseArr.join('/') + window.location.search
  }

  async createDefaultPage(){
    const id = this.getIdFromPath()
    const params = new URLSearchParams(window.location.search)
    const preloadId = params.get('designId')
    const isAuthRedirect = params.get('newAuth')
    const localId = window.localStorage.getItem('designId')
    const localDesign = window.localStorage.getItem('design')
    if(!id || !uuidValidate(id)){
      let validId = uuidv4()
      if(isAuthRedirect && localId){
        validId = localId
      }
      let url = this.getValidPath(validId)
      window.location.replace(url)
    }
    this.createContextMenu()
    if(!id){
      const dID = uuidv4()
      this.designId = dID
      let url = this.getValidPath(dID)
      if(preloadId){
        url += `?designId=${preloadId}`
      }
      window.location.replace(url)
    }else{
      try{
        const res = await fetchDesign(id)
        this.designId = id
        if(!res.design){
          if(res.exists){
            this.invalidPermissionsModal = true
           //window.location.replace(window.location.origin + '/design-editor/' + uuidv4())
            return
          }else if(res.beingEdited){
            this.beingEdited = res.beingEdited
          }else if(localId === id && localDesign){
            this.compileLocalDesign(JSON.parse(localDesign))
            this.compiled = true
            return
          }else if(preloadId){
            const { design, blank } = await getPublicDesign(preloadId)
            this.title = 'new design'
            if(blank){
              this.compileDefaultPage(uuidv4())
              this.compiled = true
            }else{
              window.localStorage.setItem('preload', preloadId)
              this.changePreset(design.pages)
              this.baseTemplate = preloadId
            }
            return
          }else{
            this.compileDefaultPage(id)
            this.title = 'new design'
            this.compiled = true
            const { userRole } = res
            if(!res.design && userRole && userRole !== 1){
              this.isPublic = true
            }
            return
          }
        }
        const { status, category, tags, description, featured, freeTemplate, canEditTeam } = res.design
        this.isPublic = res.design.public
        this.canEditTeam = canEditTeam
        if(res.design.mockupBase){
          this.mockupBase = res.design.mockupBase
          this.mockup = res.design.mockup
          this.mockupMeta = res.design.mockupMeta
        }
        this.publicDesignProps = { status, category, tags, description, freeTemplate, featured }
        this.compileDesign(res.design)
        this.compiled = true
        this.designId = res.design.id
        this.compiled = true
        this.saved = true
      }catch(err){
        console.log(err)
        this.errorStore.setErrorMessage('Could not load design', true)
      }
    }
  }

  calculateZoomForScreen(){
    try{
      if(!this.pages.length || !document || !document.body){
        setTimeout(() => {
          this.calculateZoomForScreen()
        }, 10)
        return
      }
      const { displayWidth, displayHeight } = this.pages[0]
      const { clientWidth, clientHeight } = document.body
      const toRemove = document.querySelector('.sidebar').offsetWidth
      let toRemoveRight = 0
      if(this.mockupBase){
        toRemoveRight = document.querySelector('.mockup').offsetWidth
      }
      const toRemoveH = document.querySelector('.header').offsetHeight
      const ratioW = (clientWidth - toRemove - toRemoveRight) / (displayWidth + 350)
      const ratioH = (clientHeight - (toRemoveH + 80)) / displayHeight
      const val = Math.min(ratioW, ratioH)
      if(val < 2 && val > 0.1){
        this.zoom = Math.floor(val * 100)
      }
      this.optimalSize = this.zoom
      this.fitValue = this.zoom
    }catch(err){
      console.log(err)
      this.optimalSize = this.zoom
      this.fitValue = this.zoom
    }
  }
  

  removeContextMenuAction(idx){
    this.contextMenu.actions.splice(idx, 1)
  }

  toggleAlign(val){
    this.alignOpen = val
  }

  toggleShift(val){
    this.shiftOpen = val
  }

  toggleContextMenu(pageX, pageY, display = true){
    this.contextMenu.xPos = pageX
    this.contextMenu.yPos = pageY
    const bgIdx = this.contextMenu.actions.findIndex(({ id }) => id === 'set-bg')
    if(bgIdx > -1){
      this.contextMenu.actions.splice(bgIdx, 1)
    }
    const layer = this.getSelectedLayer()
    const groupIdx = this.contextMenu.actions.findIndex(({ id }) => id === 'group')
    const ungroupIdx = this.contextMenu.actions.findIndex(({ id }) => id === 'ungroup')
    const nonFinalGroup = this.groups.find(({ finalGroup }) => !finalGroup)
    const ungroupAction = {
      label: 'Ungroup',
      id: 'ungroup',
      group: 3,
      disabled: false,
      icon: <ObjectUnGroupIcon />
    }
    const groupAction = {
      label: 'Group',
      id: 'group',
      group: 3,
      disabled: false,
      icon: <ObjectGroupIcon />
    }
    if(groupIdx > -1){
      this.removeContextMenuAction(groupIdx)
    }
    if(ungroupIdx > -1){
      this.removeContextMenuAction(ungroupIdx)
    }
    if(layer && layer.type === 'photo' && !layer.photoType){
      this.contextMenu.actions.push({
        label: 'Set background',
        id: 'set-bg',
        group: 2,
        disabled: false,
        icon: <SetBgIcon />
      })
    }
    if(layer && (layer.type === 'group')){
      if(layer && !layer.finalGroup && this.selectedLayer){
        this.contextMenu.actions.push(groupAction)
      }
      if(layer && layer.finalGroup && (layer.type === 'group')){
        const layers = this.getAllLayers()
        const l = layers.find(({ id }) => id === this.selectedLayer)
        if(l.type === 'group'){
          this.contextMenu.actions.push(ungroupAction)
        }
      }
    }
    this.contextMenu.display = display
  }

  createFinalGroup(){
    const layer = this.getSelectedLayer()
    if(layer.type === 'svgGroup'){

      return
    }
    const groupIdx = this.groups.findIndex(({ id, finalGroup }) => id === layer.id && !finalGroup)
    const group = this.groups[groupIdx]
    const layers = this.getAllLayers()
    const groupLayers = layers.filter(({ id }) => group.layers.includes(id))
    const groupArr = [...groupLayers, layer]
    const { id: firstId } = groupLayers[groupLayers.length - 1]
    const { pageIdx } = this.findLayerIdx(group.id)
    const firstIndex = this.pages[pageIdx].layers.findIndex(({ id }) => id === firstId)
    group.finalGroup = true
    groupLayers.forEach(l => l.groupId = group.id)
    this.pages[pageIdx].layers = this.pages[pageIdx].layers.filter(({ id }) => !group.layers.includes(id) && id !== group.id)
    this.pages[pageIdx].layers.splice(firstIndex, 0, ...groupArr)
    this.setChanged(true)
  }

  ungroupItems(){
    const layers = this.getAllLayers()
    const target = this.getSelectedLayer()
    if(target.type === 'group'){
      const groupId = target.id
      const groupLayers = layers.filter(({ id }) => target.layers.includes(id))
      groupLayers.forEach(l => l.groupId = null)
      this.groups = this.groups.filter(({ id }) => id !== groupId)
      this.deleteLayerById(groupId, true)
    }
    this.setChanged(true, false)
  }

  deselectSelectedLayer(){
    const layers = this.getAllLayers()
    const layer = layers.find(({ selected }) => selected)
    if(layer){
      const {pageIdx, layerIdx} = this.findLayerIdx(layer.id)
      this.pages[pageIdx].layers[layerIdx].selected = false
      if(layer.type === 'text'){
        layer.content = layer.content.trim()
      }
    }
    this.selectedLayer = null
    this.clearExistingGroup()
    this.unsetAllEditingText()
    this.setChanged(true, false)
  }

  deselectAllLayers(){
    const layers = this.getAllLayers()
    layers.forEach(l => {
      l.selected = false
      if(l.type === 'text'){
        l.content = l.content.trim()
      }
      if(l.type === 'text' && l.content === ''){
        this.deleteLayerById(l.id)
      }
    })
    this.selectedLayer = null
    this.clearExistingGroup()
    this.unsetAllEditingText()
    this.setChanged(true, false)
  }

  setActiveResizeDot(type){
    Object.keys(this.resizeElement).forEach(key => {
      if(key === type && !this.resizeElement[key]){
        this.resizeElement[key] = true
      }else{
        this.resizeElement[key] = false
      }
    })
  }

  setActiveResizeBar(type){
    Object.keys(this.resizeBarElement).forEach(key => {
      if(key === type && !this.resizeBarElement[key]){
        this.resizeBarElement[key] = true
      }else{
        this.resizeBarElement[key] = false
      }
    })
  }

  handleRotateMouseDown(mouseX, mouseY){
    this.rotate = true
    this.mouseStartRotateX = mouseX
    this.mouseStartRotateY = mouseY
    this.setChanged(true, false)
  }

  handleRotateMouseUp(){
    this.rotate = false
    if(this.mouseStartRotateX !== 0 || this.mouseStartRotateY !== 0){
      this.appendToHistory()
    }
    this.mouseStartRotateX = 0
    this.mouseStartRotateY = 0
    this.setChanged(true, false)
  }

  handleLayerMoveMouseDown(mouseX, mouseY, isKeyboard = false){
    if(this.selectedLayer){
      this.movingLayer = true
      this.mouseStartX = mouseX
      this.mouseStartY = mouseY
      this.setChanged(true, false)
      this.isKeyboard = isKeyboard
    }
  }
  
  handleLayerMoveMouseUp(){
    this.movingLayer = false
    this.resetGuidelines()
    this.isKeyboard = false
    if(this.mouseStartX !== 0 || this.mouseStartY !== 0){
      this.appendToHistory()
    }
    this.mouseStartX = 0
    this.mouseStartY = 0
    this.setChanged(true, false)
    const zoom = this.zoom / 100
    if(this.newLayerPage){
      const newPage = this.pages.find(({ id }) => id === this.newLayerPage)
      const layers = this.getAllLayers()
      const selectedCopy = { ...layers.find(({ id }) => id === this.selectedLayer) }
      if(selectedCopy.type === 'text'){
        selectedCopy.content = selectedCopy.content.trim()
      }
      let prevPageId
      this.pages.forEach(page => {
        page.layers = page.layers.filter(({ id }) => {
          if(id === this.selectedLayer){
            prevPageId = page.id
          }
          return id !== this.selectedLayer
        })
      })
      const {top: rectTop} = document.querySelector(`[data-id="${btoa(newPage.id)}"]`).getBoundingClientRect()
      const {top: prevRect} = document.querySelector(`[data-id="${btoa(prevPageId)}"]`).getBoundingClientRect()
      let topOffset = rectTop / zoom
      const prevTop = prevRect / zoom
      if(selectedCopy.type === 'group'){
        const prevPage = this.getPage(prevPageId)
        const groupedLayers = prevPage.layers.filter(({ id }) => selectedCopy.layers.includes(id))
        prevPage.layers = prevPage.layers.filter(({ id }) => !selectedCopy.layers.includes(id))
        groupedLayers.forEach(layer => {
          if(layer.type === 'text'){
            layer.content = layer.content.trim()
          }
          layer.yPos += prevTop
          layer.yPos -= topOffset
          newPage.layers.push(layer)
        })
      }
      selectedCopy.yPos += prevTop
      selectedCopy.yPos -= topOffset
      if(selectedCopy.type === 'text'){
        const idx = this.pages.findIndex(({ id: pageId }) => pageId === newPage.id)
        this.textStyleToolbars = this.textStyleToolbars.filter(({ id }) => id !== selectedCopy.id)
        const newId = uuidv4()
        this.textStyleToolbars.push(new TextStyleToolbar(newId))
        const {
          content,
          size,
          xPos,
          yPos,
          font,
          weight,
          scale,
          rotation,
          width,
          height,
          displayHeight,
          displayWidth,
          originalDisplayHeight,
          originalDisplayWidth,
          frameHeight,
          frameWidth,
          xCrop,
          yCrop,
          lineHeight,
          spacing,
          opacity,
          italic,
          underline,
          groupId,
          editorHeight,
          editorWidth,
          textAlign,
          editing,
          textShadow,
          alignMap
        } = selectedCopy
        const updated = this.updateTextLayer(selectedCopy)
        this.pages[idx].layers.push(new TextElement(
          newId,
          content,  
          textShadow ? textShadow : { x: 0, y: 0, display: false, color: '#000' },
          size,
          xPos,
          yPos,
          font,
          updated.colors,
          weight,
          scale,
          rotation,
          width,
          height,
          displayHeight,
          displayWidth,
          originalDisplayHeight,
          originalDisplayWidth,
          frameHeight,
          frameWidth,
          xCrop,
          yCrop,
          lineHeight,
          spacing,
          opacity,
          italic,
          underline,
          groupId,
          editorHeight,
          editorWidth,
          editing,
          textAlign,
          false,
          alignMap,
        ))
        this.selectLayer(newId)
        if(updated.editing){
          this.editingTextId = newId
        }
      }else{
        newPage.layers.push(selectedCopy)
      }
      this.newLayerPage = null
    }
    if(this.outofBoundsLayer){
      this.deleteLayerById(this.outofBoundsLayer)
      this.outofBoundsLayer = null
    }
  }

  handleResizeMouseDown(mouseX, mouseY){
    this.resizingLayer = true
    this.mouseStartResizeX = mouseX
    this.mouseStartResizeY = mouseY
    this.setChanged(true, false)
  }

  checkLayerBounds(pageId, layerId){
    const pageElements = document.querySelectorAll('.workarea__page')
    const layerElement = document.querySelector(`[data-id="${btoa(layerId)}"]`)
    const pageElement = document.querySelector(`[data-id="${btoa(pageId)}"]`)
    if(!layerElement || !pageElement){
      return
    }
    const yCords = []
    const yMap = []
    pageElements.forEach((p, idx) => {
      const { y, height } = p.getBoundingClientRect()
      yMap.push({
        id: atob(p.getAttribute('data-id')),
        yMin: y,
        yMax: y + height + 25
      })
      yCords.push(y)
    })
    const minY = Math.min(...yCords)
    const maxY = Math.max(...yCords)
    const { x: pageX, height: pageH, width: pageW } = pageElement.getBoundingClientRect()
    const pageMaxY = maxY + pageH
    const pageMaxX = pageX + pageW
    const { x, y, width, height } = layerElement.getBoundingClientRect()
    const boundsX = pageX > x + width || x > pageMaxX
    const boundsY = minY > y + height || y > pageMaxY
    return boundsX || boundsY
  }

  handleResizeMouseUp(){
    this.resizingLayer = false
    const layerId = this.selectedLayer
    const { pageIdx } = this.findLayerIdx(layerId)
    if(pageIdx > -1){
      const offPage = this.checkLayerBounds(this.pages[pageIdx].id, layerId)
      if(offPage){
        this.outofBoundsLayer = layerId
        this.mouseStartResizeX = 0
        this.mouseStartResizeY = 0
        if(this.outofBoundsLayer){
          this.deleteLayerById(this.outofBoundsLayer)
          this.outofBoundsLayer = null
        }
        this.appendToHistory()
      }
    }
    Object.keys(this.resizeElement).forEach(key => {
      this.resizeElement[key] = false
    })
    if(this.mouseStartResizeX !== 0 || this.mouseStartResizeY !== 0){
      this.appendToHistory()
    }
    this.mouseStartResizeX = 0
    this.mouseStartResizeY = 0
    this.setChanged(true, false)
  }

  handleResizeBarMouseDown(mouseX, mouseY){
    this.resizingLayerBar = true
    this.mouseStartResizeX = mouseX
    this.mouseStartResizeY = mouseY
    this.setChanged(true, false)
  }

  handleResizeBarMouseUp(){
    this.resizingLayerBar = false
    Object.keys(this.resizeBarElement).forEach(key => {
      this.resizeBarElement[key] = false
    })
    if(this.mouseStartResizeX !== 0 || this.mouseStartResizeY !== 0){
      this.appendToHistory()
    }
    this.mouseStartResizeX = 0
    this.mouseStartResizeY = 0
    this.setChanged(true, false)
  }

  copyLayer(layerId, toolbar = false) {
    let pageIdx
    let layer
    let layerIdx
    if(this.cutLayer){
      layer = this.cutLayer
    }
    if(this.copiedLayer){
      const data = this.findLayerIdx(layerId)
      pageIdx = data.pageIdx
      layerIdx = data.layerIdx
      layer = this.pages[pageIdx].layers[layerIdx]
    }
    if(toolbar){
      const data = this.findLayerIdx(this.selectedLayer)
      layerIdx = data.layerIdx
      pageIdx = data.pageIdx
      layer = this.pages[pageIdx].layers[layerIdx]
      this.copiedLayer = layer
    }
    if (!layer) {
      return;
    }
    layer.selected = false;
    this.setChanged(true)
    switch (layer.type) {
      case "element":
        //const id = this.insertElementToPage({ ...layer, selected: true })
        const { id: eid } = this.duplicateLayer(layer.xPos + 10, layer.yPos + 10)
        this.selectLayer(eid)
        this.appendToHistory()
        break;
      case 'svgGroup':
      case "photo":
        //this.insertPhotoToPage({ ...layer, urls: { regular: layer.dataSource }, selected: true })
        this.copiedLayer = layer
        const { id: lid } = this.duplicateLayer(layer.xPos + 10, layer.yPos + 10)
        this.selectLayer(lid)
        this.appendToHistory()
        break;
      case "text":
        layer.content = layer.content.trim()
        const { id: tid } = this.duplicateLayer(layer.xPos, layer.yPos + 30)
        this.selectLayer(tid)
        this.appendToHistory()
        break;
      case 'group':
        this.copiedLayer = layer
        const { id: gid } = this.duplicateLayer(-layer.xPos, -layer.yPos)
        this.selectLayer(gid)
        this.appendToHistory()
      default:
        break;
    }
  }

  shiftGroupedLayers(group, to, page = 0, toFront = true){
    const { id, layers } = group
    let pageLayers = [...this.pages[page].layers]
    let start = to - 1 - (layers.length - 1)
    if(!toFront){
      start = 0
    }
    const groupLayers = []
    pageLayers.forEach((l) => {
      if(layers.includes(l.id)){
        groupLayers.push(l)
      }
    })
    groupLayers.push(group)
    pageLayers = pageLayers.filter(({ id }) => !layers.includes(id))
    pageLayers = pageLayers.filter(({ id: gid }) => id !== gid)
    pageLayers.splice(start, 0, ...groupLayers)
    this.pages[page].layers = pageLayers
    this.setChanged(true)
  }

  shiftLayerFully(layerId, toFront = true, page = 0){
    if(page === -1 || !layerId){
      return
    }
    const idx = this.pages[page].layers.findIndex(l => l.id === layerId)
    const layer = this.pages[page].layers[idx]
    if(((!toFront && idx === 0) || (toFront && idx === this.pages[page].layers.length - 1)) && layer.type !== 'group'){
      return
    }
    let to = toFront ? this.pages[page].layers.length - 1 : 0
    const pageLayers = [...this.pages[page].layers]
    if(layer.type === 'group'){
      this.shiftGroupedLayers(layer, to, page, toFront)
    }else{
      pageLayers.splice(to, 0, pageLayers.splice(idx, 1)[0])
      this.pages[page].layers = pageLayers
    }
  }

  shiftLayerIndex(layerId, toFront = true, page = 0){
    const idx = this.pages[page].layers.findIndex(l => l.id === layerId)
    const layer = this.pages[page].layers[idx]
    if((!toFront && idx === 0) || (toFront && idx === this.pages[page].layers.length - 1) && layer.type !== 'group'){
      return
    }
    let to = toFront ? idx + 1 : idx - 1
    const pageLayers = [...this.pages[page].layers]
    const nextLayer = pageLayers[to]
    let nextGroup = null
    if(nextLayer && nextLayer.id){
      if(nextLayer.type === 'group'){
        nextGroup = nextLayer
      }
      let isSelf = false
      this.groups.forEach(group => {
        if(group.layers.includes(nextLayer.id) && layerId !== group.id){
          nextGroup = group
        }
        if(layerId === group.id){
          isSelf = true
        }
      })
      if(isSelf && layer.type === 'group'){
        const possibleGroupIdx = idx - layer.layers.length - 1
        const nl = this.pages[page].layers[possibleGroupIdx]
        if(nl && nl.type === 'group'){
          nextGroup = nl
        }
      }
    }
    if(nextGroup && layer.type !== 'group'){
      to = toFront ? nextGroup.layers.length + 1 : idx - nextGroup.layers.length - 1
    }
    if(layer.type === 'group'){
      this.shiftGroupedLayers(layer, to, page)
    }else{
      pageLayers.splice(to, 0, pageLayers.splice(idx, 1)[0])
      this.pages[page].layers = pageLayers
    }
    this.setChanged(true)
  }
  
 
  rotateLayer(layer, clientX, clientY, x, y, width, height, ignoreWait = false, snap = false){
    if(!this.wait || ignoreWait){
      this.wait = true
      const layerX = x + width / 2
      const layerY = y + height / 2
      const rad = Math.atan2(layerY - clientY, layerX - clientX)
      const angle = (rad * (180 / Math.PI)) + 90
      const rotationAngle = Math.ceil(angle)
      let offSetAngle = rotationAngle <= 180 ? rotationAngle : rotationAngle - 360
      if (snap) {
        offSetAngle =
          (offSetAngle > 0 ? 1 : -1) *
          Math.abs(Math.round(offSetAngle / 15)) *
          15;
      }
      const rotationDelta = layer.rotation - offSetAngle
      if (layer.type === "element") {
        this.rotateLayerElement(layer, offSetAngle)
      } else {
        layer.rotation = offSetAngle
      }
      if (layer && layer.type === 'group') {
        const Pr = {
          x: layer.xPos + layer.displayWidth / 2,
          y: layer.yPos + layer.displayHeight / 2
        }
        const layers = this.getAllLayers()
        const groupedLayers = layers.filter(l => layer.layers.includes(l.id))
        groupedLayers.forEach(l => {
          l.type === "element" ?
            this.rotateGroupElementLayer(l, Pr, rotationDelta) :
            this.rotateGroupLayer(l, Pr, rotationDelta)
        })
      }
      setTimeout(() => {
        this.wait = false
      }, 75)
    }
  }


  rotateLayerElement(layer, rotation) {
    const rotationOld = layer.rotation
    const delta = layer.rotation - rotation
    const P1 = {
      x: layer.xPos,
      y: layer.yPos
    };
    const P4 = {
      x: P1.x + layer.displayWidth,
      y: P1.y + layer.displayHeight
    };
    const P4rotated = rotatePoint(rotationOld, P1, P4)
    const Pr = scalePoint(0.5, P1, P4rotated)
    const P1rotated = rotatePoint(-1 * delta, Pr, P1)
    const xPosNew = P1rotated.x
    const yPosNew = P1rotated.y
    layer.rotation = rotation;
    layer.xPos = xPosNew
    layer.yPos = yPosNew
  }

  // transform-origin top left
  rotateGroupElementLayer(layer, groupCenter, rotation) {
    const rotationDelta = -1 * rotation 
    const P1 = {
      x: layer.xPos, y: layer.yPos
    }
    const P1rotatedPrim = rotatePoint(rotationDelta, groupCenter, P1)
    layer.xPos = P1rotatedPrim.x - P1.x + layer.xPos
    layer.yPos = P1rotatedPrim.y - P1.y + layer.yPos

    layer.rotation = rotationDelta + layer.rotation
  }

  // transform-origin center
  rotateGroupLayer(layer, groupCenter, rotation) {
    // layer corners and center
    const P1 = {
      x: layer.xPos, y: layer.yPos
    }
    const P4 = {
      x: P1.x + layer.displayWidth, y: P1.y + layer.displayHeight
    }
    const Pr = {
      x: P1.x + layer.displayWidth / 2,
      y: P1.y + layer.displayHeight / 2
    }
    const rotationDelta = -1*rotation 
    // rotate layer corners
    const P1rotated = rotatePoint(layer.rotation, Pr, P1);
    const P1rotatedPrim = rotatePoint(rotationDelta, groupCenter, P1rotated);
    // get opposite corner for new center calc and rotate
    const P4rotated = rotatePoint(layer.rotation, Pr, P4);
    const P4rotatedPrim = rotatePoint(rotationDelta, groupCenter, P4rotated);
    // calc new center and get new P1
    const newCenterPoint = scalePoint(1 / 2, P4rotatedPrim, P1rotatedPrim);
    const P1rotatedPrimBack = rotatePoint(-1 * (layer.rotation + rotationDelta), newCenterPoint, P1rotatedPrim)
    layer.xPos = P1rotatedPrimBack.x - P1.x + layer.xPos
    layer.yPos = P1rotatedPrimBack.y - P1.y + layer.yPos

    layer.rotation = rotationDelta + layer.rotation
  }

  getPageMeta(){
    const page = document.querySelector('.workarea__page')
    const pageHeight = page.offsetHeight
    const pageWidth = page.offsetWidth
    const scaleSize = this.scale
    return {
      page,
      pageHeight,
      pageWidth,
      scaleSize
    }
  }

  toggleLayerLock(id){
    const { pageIdx, layerIdx } = this.findLayerIdx(id)
    if(pageIdx === -1 || layerIdx === -1){
      return
    }
    const layer = this.pages[pageIdx].layers[layerIdx]
    this.pages[pageIdx].layers[layerIdx].locked = layer.locked ? false : true
  }

  async insertTextToPage(text, customX = 0, customY = 0, pageNo = null, noSelect = false, isDrag = false){
    this.checkAndCloseCropper()
    const { page, pageHeight, pageWidth, scaleSize } = this.getPageMeta()
    const { displayHeight, displayWidth } = text      
    let xPos = customX
    let yPos = customY
    if(!customX || !customY){
      xPos = (pageWidth - displayWidth) / 2
      yPos = (pageHeight - displayHeight) / 2
    }
    if(text.groupId && text.elements){
      const existingGroup = this.groups.find(({ id: exstId }) => exstId === text.groupId)
      if(existingGroup){
        text.groupId = uuidv4()
      }
      let h = 0
      const ids = []
      let prevElem
      text.elements.forEach(async (textElem) => {
        if(!customX || !customY){
          xPos = (pageWidth - textElem.displayWidth) / 2
          yPos = (pageHeight - textElem.displayHeight) / 2
        }
        const tid = uuidv4()
        const toolbar = new TextStyleToolbar(tid)
        this.textStyleToolbars.push(toolbar)
        const elem = { ...textElem, id: tid, xPos, yPos: yPos + h, groupId: null }
        elem.groupId = null
        text.weight > 400 ? elem.bold = true : elem.bold = false
        ids.push(tid)
        if(!pageNo){
          if(this.activePage){
            const page = this.getActivePage()
            if(!page.layers){
              page.layers = []
            }
            page.layers.push(elem)
          }else if(!this.activePage && this.selectedLayer) {
            const { pageIdx } = this.findLayerIdx(this.selectedLayer)
            this.pages[pageIdx].layers.push(elem)
          } else {
            this.pages[0].layers.push(elem)
          }
        }else{
          this.pages[pageNo].layers.push(elem)
        }
      })
      setTimeout(() => {
        const layers = []
        let pageIndex = pageNo
        this.pages.forEach((p, i) => {
          p.layers.forEach(l => {
            if(ids.includes(l.id)){
              pageIndex = i
              layers.push(l)
            }
          })
        })
        let addY = 0
        const zoom = this.zoom / 100
        ids.forEach((textLayerId, idx) => {
          const { height: domelHeight } = document.querySelector(`[data-id="${btoa(textLayerId)}"] p`).getBoundingClientRect()
          if(idx > 0){
            const foundLayer = this.pages[pageIndex].layers.find(({ id: lid }) => lid === textLayerId)
            foundLayer.yPos += addY
          }
          addY += (domelHeight / zoom)
        })
        const { xPos, yPos, groupHeight, groupWidth } = this.calculateGroupDimensions(layers)
        const group = new LayerGroup(
          text.groupId,
          groupHeight,
          groupWidth,
          groupHeight,
          groupWidth,
          groupHeight,
          groupWidth,
          groupWidth,
          groupHeight,
          xPos,
          yPos,
          0,
          0,
          this.scale,
          0,
          ids,
          false,
          false,
          null
        )
        this.pages[pageIndex].layers.push(group)
        this.groups.push(group)
        this.appendToHistory()
        this.setChanged(true)
        this.selectLayer(text.groupId)
      }, isDrag ? 75 : 30)
      this.unsetActivePage()
      return text.groupId
    }else{
      const id = uuidv4()
      const toolbar = new TextStyleToolbar(id)
      this.textStyleToolbars.push(toolbar)
      const textElement = { ...text, id, xPos, yPos }
      text.weight > 400 ? textElement.bold = true : textElement.bold = false
      if(!pageNo){
        if(this.activePage){
          const page = this.getActivePage()
          if(!page.layers){
            page.layers = []
          }
          page.layers.push(textElement)
        }else if(!this.activePage && this.selectedLayer) {
          const { pageIdx } = this.findLayerIdx(this.selectedLayer)
          this.pages[pageIdx].layers.push(textElement)
        } else {
          this.pages[0].layers.push(textElement)
        }
      }else{
        this.pages[pageNo].layers.push(textElement)
      }
      this.appendToHistory()
      this.setChanged(true)
      this.unsetActivePage()
      if(noSelect){
        return id
      }
      this.selectLayer(id)
      return id
    }
  }

  setCopiedLayer(layerId){
    const layer = this.getAllLayers().find(({ id }) => id === layerId)
    this.copiedLayer = layer
  }

  duplicateLayer(x, y, pageno = null, ignoreOffset = false){
    if(this.copiedLayer || this.cutLayer){
      let copy = {...this.copiedLayer, selected: false}
      if(this.cutLayer){
        copy = { ...this.cutLayer, selected: false }
      }
      const prevId = copy.id
      let pageIdx
      if(this.cutLayer){
        pageIdx = this.cutIndex
      }else{
        const data = this.findLayerIdx(copy.id)
        pageIdx = data.pageIdx
      }
      const id = uuidv4()
      copy.id = id
      if(!isNaN(y) && !isNaN(x)){
        copy.yPos = y
        copy.xPos = x
      }
      const zoomAmount = this.zoom / 100
      if(typeof(pageno) === 'number' && pageno !== -1 && pageIdx !== pageno && !ignoreOffset){
        const targetPage = this.pages[pageno]
       // const { top: offsetTop } = document.querySelector(`[data-id="${btoa(targetPage.id)}"]`).getBoundingClientRect()
        //console.log(`[data-id="${btoa(targetPage.id)}"]`)
        let num = pageno === 0 ? 1 : pageno
        const offset = 20 + (targetPage.height * num)
        if(isNaN(y)){
          copy.xPos = targetPage.height * num
        }
        if(pageno > pageIdx){
          copy.yPos -= offset
        }else{
          copy.yPos += offset
        }
      }
      if(copy.type === 'svgGroup' || copy.type === 'svg'){
        const colors = []
        copy.assetColors.forEach(color => {
          colors.push({
            ...color
          })
        })
        copy.assetColors = colors
      }
      if(copy.type === 'text'){
        this.textStyleToolbars.push(new TextStyleToolbar(copy.id))
        copy.content = copy.content.trim()
        const shadow = { ...copy.textShadow }
        copy.textShadow = shadow
        this.pages[pageIdx].layers.push(copy)
        this.cutLayer = null
        this.copiedLayer = null
        return copy
      }
      if(copy.type === 'group'){
        const layers = this.getAllLayers()
        let groupedLayers
        if(this.cutLayer){
          groupedLayers = this.cutGroupLayers
        }else{
          groupedLayers = layers.filter(l => this.copiedLayer.layers.includes(l.id))
        }
        const group = new LayerGroup(
          id,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          this.scale,
          0,
          [],
          copy.finalGroup,
          false,
          false
        )
        if(!copy.finalGroup){
          this.clearExistingGroup(prevId)
        }
        const realLayers = []
        let isCut = !!this.cutLayer
        groupedLayers.forEach(l => {
          if(isCut){
            this.cutLayer = l
            if(copy.finalGroup){
              this.cutLayer.groupId = id
            }
            this.copiedLayer = null
          }else{
            this.copiedLayer = l
            if(copy.finalGroup){
              this.copiedLayer.groupId = id
            }
            this.cutLayer = null
          }
          let lx = l.xPos + x
          let ly = l.yPos + y
          if(l.xPos > x){
            lx = l.xPos - x
          }
          if(l.yPos > y){
            ly = l.yPos - y
          }
          const newLayer = this.duplicateLayer(lx, ly, pageno)
          group.layers.push(newLayer.id)
          realLayers.push(newLayer)
        })
        //Wait for dom changes to migrate
        setTimeout(() => {
          const { groupHeight, groupWidth, xPos, yPos } = this.calculateGroupDimensions(realLayers)
          group.height = groupHeight
          group.width = groupWidth
          group.xPos = xPos
          group.yPos = yPos
          group.displayHeight = groupHeight
          group.displayWidth = groupWidth
          group.originalDisplayHeight = groupHeight
          group.originalDisplayWidth = groupWidth
          group.frameHeight = groupHeight
          group.finalGroup = copy.finalGroup
          group.frameWidth = groupWidth
        }, 10)
        this.pages[pageIdx].layers.push(group)
        this.groups.push(group)
        this.selectLayer(id)
        this.appendToHistory()
        this.cutLayer = null
        this.cutIndex = 0
        this.copiedLayer = null
        return group
      }
      let pasteIdx = pageIdx
      if(typeof(pageno) === 'number' && pageno !== -1){
        pasteIdx = pageno
      }
      this.pages[pasteIdx].layers.push(copy)
      this.cutLayer = null
      this.copiedLayer = null
      this.appendToHistory()
      this.setChanged(true)
      return copy
    }else{
      return
    }
  }

  insertElementToPage(element){
    this.checkAndCloseCropper()
    const { pageHeight, pageWidth } = this.getPageMeta()
    const { dataSource, displayWidth, displayHeight, originX, originY, frameHeight, frameWidth, xCrop, yCrop, fillHex, width, height } = element
    const xPos = (pageWidth - width) / 2
    const yPos = (pageHeight - height) / 2
    const id = uuidv4();
    const elementToAdd = new Element(
      id,
      dataSource,
      height,
      width,
      displayHeight,
      displayWidth,
      frameHeight,
      frameWidth,
      yPos,
      xPos,
      xCrop,
      yCrop,
      1,
      1,
      fillHex,
      0,
      null,
      null,
      element.name,
      {
        x: 1,
        y: 1,
        z: 1
      },
      originX || 'left',
      originY || 'top'
    )
    if(this.activePage){
      const page = this.getActivePage()
      page.layers.push(elementToAdd)
    } if(!this.activePage && this.selectedLayer) {
      const { pageIdx } = this.findLayerIdx(this.selectedLayer)
      this.pages[pageIdx].layers.push(elementToAdd)
    } else if(!this.activePage && !this.selectedLayer) {
      this.pages[0].layers.push(elementToAdd)
    }
    this.appendToHistory()
    this.setChanged(true)
    if(!this.selectedLayer){
      this.selectLayer(id)
    }
    this.unsetActivePage()
    return id
  }

  calculatePhotoSize(originalWidth, pageWidth, originalHeight, pageHeight){
    const aspectW = originalWidth / pageWidth
    const aspectH = originalHeight / pageHeight
    let displayHeight = 0
    let displayWidth = 0
    if(aspectW > aspectH){
      displayWidth = pageWidth
      displayHeight = originalHeight / aspectW
    }else{
      displayHeight = pageHeight
      displayWidth = originalWidth / aspectH
    }
    return {
      displayHeight,
      displayWidth
    }
  }
  
  insertPhotoFromPaste(url, assetId){
    this.checkAndCloseCropper()
    const data = {
      urls: {
        regular: url
      },
      width: 0,
      height: 0,
      assetId,
      isUpload: true
    }
    const el = document.createElement('img')
    el.style.zIndex = '-100'
    el.id = 'temp-uploaded-photo'
    el.src = url
    el.onload = () => {
      const temp = document.querySelector('#temp-uploaded-photo')
      const { naturalHeight, naturalWidth } = temp
      data.width = naturalWidth
      data.height = naturalHeight
      data.isUpload = true
      this.insertPhotoToPage(data, false)
      temp.remove()
    }
    document.body.appendChild(el)
  }

  async ungroupSVGGroup(layer){
    return
    const { assetColors, parsed } = await parseSvg(layer.dataSource)
    const layerData = []
    this.createSVGLayers(parsed, layerData, parsed.children, assetColors, false)
    const { pageHeight, pageWidth } = this.getPageMeta()
    this.insertSVGLayers(layerData, pageWidth, pageHeight)
    this.deleteLayerById(layer.id)
    this.setChanged(true)
    this.appendToHistory()
  }

  getDefsString(child){
    let target = ''
    if(child.name === 'linearGradient'){
      target += `<linearGradient `
    }else{
      target += `<${child.name} `
    }
    Object.keys(child.attributes).forEach(key => {
      target += `${key}="${child.attributes[key]}" `
    })
    if(child.name === 'linearGradient'){
      target += '>'
    }
    if(child.children.length){
      child.children.forEach(nestedChild => {
        target += this.getDefsString(nestedChild)
      })
    }
    if(child.name === 'linearGradient'){
      target += `</linearGradient>`
    }else{
      target += `/>`
    }
    return target
  }

  createSVGLayers(initialParent, target, children, assetColors, isGroup){
    children.forEach(nestedChild => {
      let noParentSize = false
      if(nestedChild.name === 'style'){
        return
      }
      if(nestedChild.name === 'g' && nestedChild.children.length){
        this.createSVGLayers(initialParent, target, nestedChild.children, assetColors, isGroup)
      }
      if(nestedChild.name === 'defs' && nestedChild.children.length){
        this.createSVGLayers(nestedChild, target, nestedChild.children, assetColors, isGroup)
        return
      }
      if(initialParent.name === 'defs'){
        let svgString = '<defs>'
        children.forEach(child => {
          svgString += this.getDefsString(child)
        })
        svgString += '</defs>'
        target.push({
          svgString,
          fillHex: 'none',
          noParentSize
        })
        return
      }
      if(nestedChild.name !== 'g'){
        let svgString = '<svg '
        if(isGroup){
          svgString = ''
        }
        const keyList = []
        Object.keys(initialParent.attributes).forEach(key => {
          if(key === 'width' || key === 'height'){
            return
          }
          if(!isGroup){
            svgString += `${key}="${initialParent.attributes[key]}" `
          }
        })
        if(!isGroup){
          svgString += 'width="100%" height="100%"'
        }
        let fillHex = ''
        if(isGroup){
          svgString += '<g>'
        }else{
          svgString += '><g>'
        }
        svgString += `<${nestedChild.name} `
        Object.keys(nestedChild.attributes).forEach(key => {
          if(key === 'fill'){
            let val = nestedChild.attributes[key]
            if(val === 'white'){
              val = '#ffffff'
            }
            if(val === 'black'){
              val = '#0000000'
            }
            fillHex = val
            svgString += ` ${key}="${val}"`
          }else{
            svgString += ` ${key}="${nestedChild.attributes[key]}"`
          }
        })
        if(!nestedChild.attributes.fill && nestedChild.attributes.class){
          const matchingColor = assetColors.find(({ className }) => className == nestedChild.attributes.class)
          if(matchingColor){
            svgString += ` fill="${matchingColor.color}"`
            fillHex = matchingColor.color
          }
        }
        if(!nestedChild.attributes.fill && nestedChild.attributes.style && nestedChild.attributes.style.includes('fill')){
          const test = nestedChild.attributes.style.match(/fill:(#[0-9A-F]{6}|[a-z]{4,})|fill: (#[0-9A-F]{6}|[a-z]{4,})|fill: (#[0-9A-F]{6}|[a-z]{4,});|fill:(#[0-9A-F]{6}|[a-z]{4,});/ig)
          if(test && test.length){
            const match = test[0]
            const [tag, fillValue] = match.split(':')
            fillHex = fillValue.trimLeft()
          }
        }
        svgString += '/>'
        if(isGroup){
          svgString += '</g>'
        }else{
          svgString += '</g></svg>'
        }
        svgString = svgString.replace(/\n/ig, '').replace(/\r/ig, '').replace(/\t/ig, '')
        target.push({
          svgString,
          fillHex,
          noParentSize
        })
      }
    })
  }

  appendToPage(elem){
    if(this.activePage){
      const page = this.getActivePage()
      page.layers.push(elem)
    }else if(!this.activePage && this.selectedLayer) {
      const { pageIdx } = this.findLayerIdx(this.selectedLayer)
      this.pages[pageIdx].layers.push(elem)
    } else {
      this.pages[0].layers.push(elem)
    }
  }

  getSVGDimensions(id, svgString){
    const div = document.createElement('div')
    div.innerHTML = svgString
    div.style.zIndex = -10000
    div.style.opacity = 0
    div.style.position = 'absolute'
    const hash = btoa(id)
    div.id = hash
    document.body.appendChild(div)
    const el = document.querySelector(`#${hash}`)
    const { width, height, x, y } = el.getBoundingClientRect()
    const { width: boxW, height: boxH, x: boxX, y: boxY } = el.firstChild.getBBox()
    el.remove()
    return {
      width,
      height,
      x,
      y,
      boxW,
      boxH,
      boxX,
      boxY
    }
  }

  createSVGGroupFromLayers(layers){
    const { pageWidth, pageHeight } = this.getPageMeta()
    const layerData = []
    let assetColors = []
    let parent = null
    layers.forEach((layer, idx) => {
      const el = document.createElement('div')
      el.innerHTML = layer.dataSource
      layerData.push({
        html: el.firstChild.firstChild.innerHTML,
        idx
      })
      if(idx === 0){
        parent = el.firstChild
      }
      if(layer.fillHex){
        const colorIndex = assetColors.findIndex(({ color }) => color === layer.fillHex)
        if(colorIndex > -1){
          assetColors[colorIndex].occurence += 1
        }else{
          assetColors.push({
            color: layer.fillHex,
            occurence: 1
          })
        }
      }
      this.deleteLayerById(layer.id)
    })
    assetColors = assetColors.sort((a, b) => b.occurence - a.occurence)
    let str = `<svg `
    const id = uuidv4()
    const keyList = []
    Object.values(parent.attributes).forEach(({ value, name }) => {
      keyList.push(name)
      str += `${name}="${value}" `
    })
    if(!keyList.includes('width') && !keyList.includes('height')){
      str += ' width="100%" height="100%"'
    }
    str += '><g>'
    layerData.forEach(data => {
      str += `${data.html}`
    })
    str += '</g></svg>'
    const group = this.compileSVGGroup(id, str, pageWidth, pageHeight, true, assetColors, true)
    this.appendToPage(group)
    this.selectLayer(id)
    this.appendToHistory()
    this.setChanged(true)
  }

  compileSVGGroup(id, str, pageWidth, pageHeight, finalGroup, assetColors, customX = 0, customY = 0){
    const {
      width,
      height,
      x,
      y,
      boxW,
      boxH,
      boxX,
      boxY
    } = this.getSVGDimensions(id, str)
    const { displayHeight: fullHeight, displayWidth: fullWidth } = this.calculatePhotoSize(width, pageWidth, height, pageHeight)
    let sizePrecentage = 1
    if(pageWidth + pageHeight < 2000){
      sizePrecentage = 0.5
    }else{
      sizePrecentage = 0.33
    }
    const w = fullWidth * sizePrecentage
    const h = fullHeight * sizePrecentage
    let xPos = (pageWidth - w) / 2
    let yPos = (pageHeight - h) / 2
    if(customX && customY){
      xPos = customX - (w / 2)
      yPos = customY + (h / 2)
    }
    const group = new SVGGroup(
      id,
      str,
      h,
      w,
      h,
      w,
      boxH,
      boxW,
      boxX,
      boxY,
      xPos,
      yPos,
      0,
      0,
      assetColors,
      null,
      false,
      0,
      finalGroup
    )
    return group
  }

  createSVGGroup(layerData, pageWidth, pageHeight, photo, finalGroup = true, customX = 0, customY = 0){
    let str = `<svg `
    const attr = photo.rawSVG.attributes
    const keyList = []
    const id = uuidv4()
    Object.keys(attr).forEach(key => {
      if(key === 'width' || key === 'height'){
        return
      }
      str += `${key}="${attr[key]}" `
    })
    str += ' width="100%" height="100%"'
    str += '><g>'
    layerData.forEach(data => {
      str += data.svgString
    })
    str += '</g></svg>'
    const group = this.compileSVGGroup(id, str, pageWidth, pageHeight, finalGroup, photo.assetColors, customX, customY)
    this.appendToPage(group)
    this.selectLayer(id)
    this.appendToHistory()
    this.setChanged(true)
  }

  changeFill(el, oldFillValue, fillValue){
    if(el.nodeName === 'defs'){
      return
    }
    const attr = el.getAttribute('fill')
    const stroke = el.getAttribute('stroke')
    if(attr && !attr.includes('url') && attr !== 'inherit' && attr.toLowerCase() === oldFillValue.toLowerCase()){
      el.setAttribute('fill', fillValue)
    }
    if(!attr && stroke && !stroke.includes('url') && stroke.toLowerCase() === oldFillValue.toLowerCase()){
      el.setAttribute('stroke', fillValue)
    }
    if(el.style.fill && !attr){
      let styleAttr = el.getAttribute('style')
      const test = styleAttr.match(/fill:(#[0-9A-F]{6}|[a-z]{4,})|fill: (#[0-9A-F]{6}|[a-z]{4,})|fill: (#[0-9A-F]{6}|[a-z]{4,});|fill:(#[0-9A-F]{6}|[a-z]{4,});/ig)
      if(test && test.length){
        const match = test[0]
        const rawValue = match.replace('fill:', '').replace('fill: ', '')
        if(rawValue.toLowerCase() === oldFillValue.toLowerCase()){
          styleAttr = styleAttr.replace(match + ';', ``)
          el.setAttribute('style', styleAttr)
          el.setAttribute('fill', fillValue)
        }
      }
    }
    if(el.hasChildNodes){
      el.childNodes.forEach(child => {
        if(child.nodeName === 'defs' || child.nodeName === 'stop' || child.nodeName === 'linearGradient'){
          return
        }else{
          this.changeFill(child, oldFillValue, fillValue)
        }
      })
    }
  }

  changeSVGGroupFill(groupId, fillValue){
    const layer = this.getLayer(groupId)
    const assetColors = [...layer.assetColors]
    const idx = assetColors.findIndex(({ color }) => color === this.editingColor)
    if(idx > -1){
      assetColors[idx].color = fillValue
    }
    const el = document.createElement('div')
    el.innerHTML = layer.dataSource
    this.changeFill(el, this.editingColor, fillValue)
    layer.dataSource = el.innerHTML
    layer.assetColors = assetColors
    this.editingColor = fillValue
    this.setChanged(true)
    this.appendToHistory()
  }

  getSVGGroupColors(l){
    const colorList = []
    const { pageIdx, layerIdx } = this.findLayerIdx(l.id)
    if(pageIdx > -1){
      const target = this.pages[pageIdx].layers[layerIdx]
      const layer = { ...target }
      layer.assetColors = [...target.assetColors]
      if(layer.type === 'svgGroup'){
        const sorted = layer.assetColors.sort((a, b) => b.occurence - a.occurence)
        for(let i = 0; i < sorted.length; i++){
          if(i < 5){
            colorList.push(sorted[i])
          }
        }
      }
    }
    return colorList
  }

  setEditingColor(value){
    if(!value){
      this.editingColor = null
    }else{
      this.editingColor = value
    }
  }
  
  insertSVGLayers(layerData, pageWidth, pageHeight){
    layerData.forEach(layer => {
      const div = document.createElement('div')
      const { noParentSize, svgString } = layer
      div.innerHTML = svgString
      div.style.zIndex = -10000
      div.style.opacity = 0
      div.style.position = 'absolute'
      const id = uuidv4()
      const hash = btoa(id)
      div.id = hash
      document.body.appendChild(div)
      const el = document.querySelector(`#${hash}`)
      const { width, height, x, y } = el.firstChild.getBoundingClientRect()
      const { width: bw, height: bh, x: boxX, y: boxY } = el.firstChild.getBBox()
      const svgXPos = (pageWidth - width) / 2
      const svgYPos = (pageHeight - height) / 2
      let boxW = bw
      let boxH = bh
      boxW += 20
      boxH += 20
      const svg = new SVGElement(
        uuidv4(),
        svgString,
        height,
        width,
        height,
        width,
        height,
        width,
        boxH,
        boxW,
        boxX,
        boxY,
        svgXPos,
        svgYPos,
        0,
        0,
        layer.fillHex,
        null,
        false,
        0
      )
      this.appendToPage(svg)
      el.remove()
    })
  }

  copySVGItem(data){
    const copy = {}
    copy.rawSVG = data.rawSVG
    copy.parsedSVG = data.parsedSVG
    copy.assetColors = []
    data.assetColors.forEach(color => {
      copy.assetColors.push({...color})
    })
    return copy
  }

  insertSVGElement(photo, pageWidth, pageHeight, isGroup = false, customX = 0, customY = 0){
    this.unsetActivePage()
    const layerData = []
    const photoCopy = this.copySVGItem(photo)
    this.createSVGLayers(photoCopy.rawSVG, layerData, photoCopy.rawSVG.children, photoCopy.assetColors, isGroup)
    this.createSVGGroup(layerData, pageWidth, pageHeight, photoCopy, false, customX, customY)
    this.appendToHistory()
    this.setChanged(true)
  }

  insertPhotoToPage(photo, isGif = true){
    this.checkAndCloseCropper()
    const { page, pageHeight, pageWidth, scaleSize } = this.getPageMeta()
    const { urls: { regular: url }, height: originalHeight, width: originalWidth } = photo
    const id = uuidv4();
    const { displayHeight, displayWidth } = this.calculatePhotoSize(originalWidth, pageWidth, originalHeight, pageHeight)
    const xPos = (pageWidth - displayWidth) / 2
    const yPos = (pageHeight - displayHeight) / 2
    let source = url
    if(photo.parsedSVG){
      this.insertSVGElement(photo, pageWidth, pageHeight, true)
      return
    }
    const photoElement = new PhotoElement(
      id,
      source,
      originalHeight,
      originalWidth,
      displayHeight,
      displayWidth,
      yPos,
      xPos,
      1,
      0,
      0,
      displayWidth,
      displayHeight,
      0,
      displayHeight,
      displayWidth,
      null,
      photo.photoType ? photo.photoType : null,
      photo.frames ? photo.frames : null,
      {
        opacity: 100,
        brightness: 100,
        contrast: 100,
        saturation: 100,
        blur: 0
      },
      photo.isUpload,
      photo.assetId,
      false,
      null,
    )
    this.appendToPage(photoElement)
    this.resizeInPrecentage(photoElement, 5)
    this.appendToHistory()
    this.setChanged(true)
    this.selectLayer(id)
    this.unsetActivePage()
    return id
  }

  resizeInPrecentage({ id: photoId, displayHeight, displayWidth, scale }, precentage, larger = false){
    const page = this.pages[0]
    const layerIdx = page.layers.findIndex(({ id }) => id === photoId)
    const layerCopy = { ...page.layers[layerIdx] }
    let newScale = scale - precentage / 100
    if(larger){
      newScale = scale + precentage / 100
    }
    if(newScale > 0.05){
      const newWidth = displayWidth * newScale
      const newHeight = displayHeight * newScale
      layerCopy.displayWidth = newWidth
      layerCopy.displayHeight = newHeight
      layerCopy.frameHeight = newHeight
      layerCopy.frameWidth = newWidth
      layerCopy.originalDisplayWidth = newWidth
      layerCopy.originalDisplayHeight = newHeight
      layerCopy.scale = newScale
      layerCopy.xPos = (page.displayWidth - newWidth)/2
      layerCopy.yPos = (page.displayHeight - newHeight)/2
    }

    page.layers[layerIdx] = layerCopy
  }

  calculateDimensions(height, width, clientX, clientY, layer, groupLayers) {
    if (layer.type === "element") {
      return this.calculateElementDimensions(height, width, clientX, clientY, layer, groupLayers)
    } else {
      return this.calculateImageDimensions(height, width, clientX, clientY, layer, groupLayers)
    }
  }

  calculateBackgroundImageDimensions(height, width, xPos, yPos, clientX, clientY){
    const { bottomLeft, bottomRight, topLeft, topRight } = this.resizeElement
    const rotation = 0
    let xPosNew = xPos
    let ratio = 0
    let newHeight = height
    let newWidth = width
    let yPosNew = yPos
    if(topLeft){
      // get distance between parallel lines
      const slope = Math.tan((rotation) * Math.PI / 180 - 45)
      const b0 = -1 * slope * this.mouseStartResizeX + this.mouseStartResizeY
      const b1 = -1 * slope * clientX + clientY
      let dist =100/this.zoom * Math.abs(b1 - b0) / Math.sqrt(Math.pow(slope, 2) + 1)
      // check if point is above f(x) or not
      const beta = Math.atan(width / height) //+ Math.PI * (rotation) / 180
      const alpha = Math.PI / 2 - beta
      if (alpha + rotation * Math.PI / 180 > Math.PI || alpha + rotation * Math.PI / 180 < 0) {
        if (slope * clientX - slope * this.mouseStartResizeX + this.mouseStartResizeY > clientY) {
          dist = dist * -1
        }
      } else {
        if (slope * clientX - slope * this.mouseStartResizeX + this.mouseStartResizeY < clientY) {
          dist = dist * -1
        }
      }
      const heightToAdd = dist * Math.sin(alpha) / Math.cos(Math.PI / 4 - beta)
      ratio = (height + heightToAdd) / height
      // update layer size
      newHeight = height * ratio
      newWidth = width * ratio
      // layer center coords
      const Pr = {
        x: xPos + width / 2,
        y: yPos + height / 2
      }
      // layer corner coords
      const P1 = {
        x: xPos, y: yPos
      }
      const P4 = {
        x: P1.x + width, y: P1.y + height
      }
      const P1rotated = rotatePoint(rotation, Pr, P1)
      const P4rotated = rotatePoint(rotation, Pr, P4)
      const newP1ScaledPoint = scalePoint(ratio, P4rotated, P1rotated)
      const newCenterPoint = scalePoint(
        1 / 2,
        P4rotated,
        newP1ScaledPoint
      )
      const newP1 = rotatePoint(-1 * rotation, newCenterPoint, newP1ScaledPoint)
      const newOrigin = { x: newP1.x, y: newP1.y }
      // offset
      xPosNew = newOrigin.x - P1.x + xPos
      yPosNew = newOrigin.y - P1.y + yPos
    }
    if(bottomLeft){
      const slope = Math.tan((rotation) * Math.PI / 180 + 45)
      const b0 = -1 * slope * this.mouseStartResizeX + this.mouseStartResizeY
      const b1 = -1 * slope * clientX + clientY
      let dist = 100/this.zoom * Math.abs(b1 - b0) / Math.sqrt(Math.pow(slope, 2) + 1)
      const beta = Math.atan(width / height)
      let alpha = Math.PI / 2 - beta
      // check if point is above f(x) or not
      if (beta + rotation * Math.PI / 180 > Math.PI / 2 || beta + rotation * Math.PI / 180 < Math.PI / -2) {
        if (slope * clientX - slope * this.mouseStartResizeX + this.mouseStartResizeY < clientY) {
          dist = dist * -1
        }
      } else {
        if (slope * clientX - slope * this.mouseStartResizeX + this.mouseStartResizeY > clientY) {
          dist = dist * -1
        }
      }
      const heightToAdd = dist * Math.sin(alpha) / Math.cos(Math.PI / 4 - beta)
      // update layer size
      ratio = (height + heightToAdd) / height
      newHeight = height * ratio
      newWidth = width * ratio
      // layer center coords
      const Pr = {
        x: xPos + width / 2,
        y: yPos + height / 2
      }
      // layer corner coords
      const P1 = {
        x: xPos, y: yPos
      }
      const P2 = {
        x: P1.x + width, y: yPos
      }
      const P3 = {
        x: P1.x, y: P1.y + height
      }
      const P2rotated = rotatePoint(rotation, Pr, P2)
      const P3rotated = rotatePoint(rotation, Pr, P3)
      const newP3ScaledPoint = scalePoint(ratio, P2rotated, P3rotated)
      const newCenterPoint = scalePoint(
        1 / 2,
        P2rotated,
        newP3ScaledPoint
      )
      const newP3 = rotatePoint(-1 * rotation, newCenterPoint, newP3ScaledPoint)
      const newOrigin = { x: newP3.x, y: newP3.y - height * ratio}
      // offset
      xPosNew = newOrigin.x - P1.x + xPos
      yPosNew = newOrigin.y - P1.y + yPos
    }
    if(topRight){
      const slope = Math.tan((rotation) * Math.PI / 180 + 45)
      const b0 = -1 * slope * this.mouseStartResizeX + this.mouseStartResizeY
      const b1 = -1 * slope * clientX + clientY
      let dist = 100/this.zoom * Math.abs(b1 - b0) / Math.sqrt(Math.pow(slope, 2) + 1)
      // check if point is above f(x) or not
      const beta = Math.atan(width / height)  //+ Math.PI * (rotation) / 180
      let alpha = Math.PI / 2 - beta
      if (beta + rotation * Math.PI / 180 > Math.PI / 2 || beta + rotation * Math.PI / 180 < -3 * Math.PI / 4 ) {
        if (slope * clientX - slope * this.mouseStartResizeX + this.mouseStartResizeY > clientY) {
          dist = dist * -1
        }
      } else {
        if (slope * clientX - slope * this.mouseStartResizeX + this.mouseStartResizeY < clientY) {
          dist = dist * -1
        }
      }
      const heightToAdd = dist * Math.sin(alpha) / Math.cos(Math.PI / 4 - beta)
      // update layer size
      ratio = (height + heightToAdd) / height
      newHeight = height * ratio
      newWidth = width * ratio
      // layer center coords
      const Pr = {
        x: xPos + width / 2,
        y: yPos + height / 2
      }
      // layer corner coords
      const P1 = {
        x: xPos, y: yPos
      }
      const P2 = {
        x: P1.x + width, y: yPos
      }
      const P3 = {
        x: P1.x, y: P1.y + height
      }
      const P2rotated = rotatePoint(rotation, Pr, P2)
      const P3rotated = rotatePoint(rotation, Pr, P3)
      const newP2ScaledPoint = scalePoint(ratio, P3rotated, P2rotated)
      const newCenterPoint = scalePoint(
        1 / 2,
        P3rotated,
        newP2ScaledPoint
      )
      const newP2 = rotatePoint(-1 * rotation, newCenterPoint, newP2ScaledPoint)
      const newOrigin = { x: newP2.x - width * ratio, y: newP2.y }
      // offset
      xPosNew = newOrigin.x - P1.x + xPos
      yPosNew = newOrigin.y - P1.y + yPos
    }
    if(bottomRight){const slope = Math.tan((rotation) * Math.PI / 180 -45)
      const b0 = -1 * slope * this.mouseStartResizeX + this.mouseStartResizeY
      const b1 = -1 * slope * clientX + clientY
      let dist = 100/this.zoom * Math.abs(b1 - b0) / Math.sqrt(Math.pow(slope, 2) + 1)
      const beta = Math.atan(width / height)
      const alpha = Math.PI / 2 - beta
      if (alpha + rotation * Math.PI / 180 > Math.PI || alpha + rotation * Math.PI / 180 < 0) {
        if (slope * clientX - slope * this.mouseStartResizeX + this.mouseStartResizeY < clientY) {
          dist = dist * -1
        }
      } else {
        if (slope * clientX - slope * this.mouseStartResizeX + this.mouseStartResizeY > clientY) {
          dist = dist * -1
        }
      }
      const heightToAdd = dist * Math.sin(alpha) / Math.cos(Math.PI / 4 - beta)
      ratio = (height + heightToAdd) / height
      // update layer size
      newHeight = height * ratio
      newWidth = width * ratio
      // layer center coords
      const Pr = {
        x: xPos + width / 2,
        y: yPos + height / 2
      }
      // layer corner coords
      const P1 = {
        x: xPos, y: yPos
      }
      const P4 = {
        x: P1.x + width, y: P1.y + height
      }
      const P1rotated = rotatePoint(rotation, Pr, P1)
      const P4rotated = rotatePoint(rotation, Pr, P4)
      const newP4ScaledPoint = scalePoint(ratio, P1rotated, P4rotated)
      const newCenterPoint = scalePoint(
        1 / 2,
        P1rotated,
        newP4ScaledPoint
      )
      const newP1 = rotatePoint(-1 * rotation, newCenterPoint, newP4ScaledPoint)
      const newOrigin = { x: newP1.x - width * ratio, y: newP1.y - height * ratio}
      // offset
      xPosNew = newOrigin.x - P1.x + xPos
      yPosNew = newOrigin.y - P1.y + yPos
    }
    return { xPosNew, yPosNew, ratio, newHeight, newWidth }
  }

  calculateImageDimensions(height, width, clientX, clientY, layer, groupLayers) {
    const {
      xPos,
      yPos,
      xCrop,
      yCrop,
      rotation,
    } = layer
    width = layer.displayWidth
    height = layer.displayHeight
    let xCropNew = xCrop
    let yCropNew = yCrop
    let xPosNew = xPos
    let yPosNew = yPos
    let { bottomLeft, bottomRight, topLeft, topRight } = this.resizeElement
    let newWidth = width;
    let newHeight = height;
    let ratio = null;
    let pointAround = null
    const Pr = {
      x: xPos + width / 2,
      y: yPos + height / 2
    }
    const { P1, P2, P3, P4 } = getPoints(layer)
    if (topLeft) {
      // get distance between parallel lines
      const slope = Math.tan((rotation) * Math.PI / 180 - 45)
      const b0 = -1 * slope * this.mouseStartResizeX + this.mouseStartResizeY
      const b1 = -1 * slope * clientX + clientY
      let dist =100/this.zoom * Math.abs(b1 - b0) / Math.sqrt(Math.pow(slope, 2) + 1)
      // check if point is above f(x) or not
      const beta = Math.atan(width / height) //+ Math.PI * (rotation) / 180
      const alpha = Math.PI / 2 - beta
      if (alpha + rotation * Math.PI / 180 > Math.PI || alpha + rotation * Math.PI / 180 < 0) {
        if (slope * clientX - slope * this.mouseStartResizeX + this.mouseStartResizeY > clientY) {
          dist = dist * -1
        }
      } else {
        if (slope * clientX - slope * this.mouseStartResizeX + this.mouseStartResizeY < clientY) {
          dist = dist * -1
        }
      }
      const heightToAdd = dist * Math.sin(alpha) / Math.cos(Math.PI / 4 - beta)
      ratio = (height + heightToAdd) / height
      // update layer size
      newHeight = height * ratio
      newWidth = width * ratio
      const P1rotated = rotatePoint(rotation, Pr, P1)
      const P4rotated = rotatePoint(rotation, Pr, P4)
      const newP1ScaledPoint = scalePoint(ratio, P4rotated, P1rotated)
      const newCenterPoint = scalePoint(
        1 / 2,
        P4rotated,
        newP1ScaledPoint
      )
      const newP1 = rotatePoint(-1 * rotation, newCenterPoint, newP1ScaledPoint)
      const newOrigin = { x: newP1.x, y: newP1.y }
      // offset
      xPosNew = newOrigin.x - P1.x + xPos
      yPosNew = newOrigin.y - P1.y + yPos
      xCropNew = xCropNew * ratio
      yCropNew = yCropNew * ratio
      pointAround = P4rotated
    } else if (topRight) {
      const slope = Math.tan((rotation) * Math.PI / 180 + 45)
      const b0 = -1 * slope * this.mouseStartResizeX + this.mouseStartResizeY
      const b1 = -1 * slope * clientX + clientY
      let dist = 100/this.zoom * Math.abs(b1 - b0) / Math.sqrt(Math.pow(slope, 2) + 1)
      // check if point is above f(x) or not
      const beta = Math.atan(width / height)  //+ Math.PI * (rotation) / 180
      let alpha = Math.PI / 2 - beta
      if (beta + rotation * Math.PI / 180 > Math.PI / 2 || beta + rotation * Math.PI / 180 < -3 * Math.PI / 4 ) {
        if (slope * clientX - slope * this.mouseStartResizeX + this.mouseStartResizeY > clientY) {
          dist = dist * -1
        }
      } else {
        if (slope * clientX - slope * this.mouseStartResizeX + this.mouseStartResizeY < clientY) {
          dist = dist * -1
        }
      }
      const heightToAdd = dist * Math.sin(alpha) / Math.cos(Math.PI / 4 - beta)
      // update layer size
      ratio = (height + heightToAdd) / height
      newHeight = height * ratio
      newWidth = width * ratio
      const P2rotated = rotatePoint(rotation, Pr, P2)
      const P3rotated = rotatePoint(rotation, Pr, P3)
      const newP2ScaledPoint = scalePoint(ratio, P3rotated, P2rotated)
      const newCenterPoint = scalePoint(
        1 / 2,
        P3rotated,
        newP2ScaledPoint
      )
      const newP2 = rotatePoint(-1 * rotation, newCenterPoint, newP2ScaledPoint)
      const newOrigin = { x: newP2.x - width * ratio, y: newP2.y }
      // offset
      xPosNew = newOrigin.x - P1.x + xPos
      yPosNew = newOrigin.y - P1.y + yPos
      xCropNew = xCropNew * ratio
      yCropNew = yCropNew * ratio
      pointAround = P3rotated
    } else if (bottomLeft) {
      const slope = Math.tan((rotation) * Math.PI / 180 + 45)
      const b0 = -1 * slope * this.mouseStartResizeX + this.mouseStartResizeY
      const b1 = -1 * slope * clientX + clientY
      let dist = 100/this.zoom * Math.abs(b1 - b0) / Math.sqrt(Math.pow(slope, 2) + 1)
      const beta = Math.atan(width / height)
      let alpha = Math.PI / 2 - beta
      // check if point is above f(x) or not
      if (beta + rotation * Math.PI / 180 > Math.PI / 2 || beta + rotation * Math.PI / 180 < Math.PI / -2) {
        if (slope * clientX - slope * this.mouseStartResizeX + this.mouseStartResizeY < clientY) {
          dist = dist * -1
        }
      } else {
        if (slope * clientX - slope * this.mouseStartResizeX + this.mouseStartResizeY > clientY) {
          dist = dist * -1
        }
      }
      const heightToAdd = dist * Math.sin(alpha) / Math.cos(Math.PI / 4 - beta)
      // update layer size
      ratio = (height + heightToAdd) / height
      newHeight = height * ratio
      newWidth = width * ratio
      const P2rotated = rotatePoint(rotation, Pr, P2)
      const P3rotated = rotatePoint(rotation, Pr, P3)
      const newP3ScaledPoint = scalePoint(ratio, P2rotated, P3rotated)
      const newCenterPoint = scalePoint(
        1 / 2,
        P2rotated,
        newP3ScaledPoint
      )
      const newP3 = rotatePoint(-1 * rotation, newCenterPoint, newP3ScaledPoint)
      const newOrigin = { x: newP3.x, y: newP3.y - height * ratio}
      // offset
      xPosNew = newOrigin.x - P1.x + xPos
      yPosNew = newOrigin.y - P1.y + yPos
      xCropNew = xCropNew * ratio
      yCropNew = yCropNew * ratio
      pointAround = P2rotated
    } else if (bottomRight) {
      const slope = Math.tan((rotation) * Math.PI / 180 -45)
      const b0 = -1 * slope * this.mouseStartResizeX + this.mouseStartResizeY
      const b1 = -1 * slope * clientX + clientY
      let dist = 100/this.zoom * Math.abs(b1 - b0) / Math.sqrt(Math.pow(slope, 2) + 1)
      const beta = Math.atan(width / height)
      const alpha = Math.PI / 2 - beta
      if (alpha + rotation * Math.PI / 180 > Math.PI || alpha + rotation * Math.PI / 180 < 0) {
        if (slope * clientX - slope * this.mouseStartResizeX + this.mouseStartResizeY < clientY) {
          dist = dist * -1
        }
      } else {
        if (slope * clientX - slope * this.mouseStartResizeX + this.mouseStartResizeY > clientY) {
          dist = dist * -1
        }
      }
      const heightToAdd = dist * Math.sin(alpha) / Math.cos(Math.PI / 4 - beta)
      ratio = (height + heightToAdd) / height
      // update layer size
      newHeight = height * ratio
      newWidth = width * ratio
      const P1rotated = rotatePoint(rotation, Pr, P1)
      const P4rotated = rotatePoint(rotation, Pr, P4)
      const newP4ScaledPoint = scalePoint(ratio, P1rotated, P4rotated)
      const newCenterPoint = scalePoint(
        1 / 2,
        P1rotated,
        newP4ScaledPoint
      )
      const newP1 = rotatePoint(-1 * rotation, newCenterPoint, newP4ScaledPoint)
      const newOrigin = { x: newP1.x - width * ratio, y: newP1.y - height * ratio}
      // offset
      xPosNew = newOrigin.x - P1.x + xPos
      yPosNew = newOrigin.y - P1.y + yPos
      xCropNew = xCropNew * ratio
      yCropNew = yCropNew * ratio
      pointAround = P1rotated
    }
    // scale and reposition all layers within group
    if (groupLayers && ratio && pointAround) {
      groupLayers.forEach(l => {
        this.scaleGroupLayer(l, ratio, pointAround)
      })
    }
    return {
      xPosNew,
      yPosNew,
      newHeight,
      newWidth,
      xCropNew,
      yCropNew,
    }
  }


  calculateElementDimensions(height, width, clientX, clientY, layer, groupLayers) {
    const {
      xPos,
      yPos,
      xCrop,
      yCrop,
      rotation,
    } = layer
    width = layer.displayWidth
    height = layer.displayHeight
    let xCropNew = xCrop
    let yCropNew = yCrop
    let xPosNew = xPos
    let yPosNew = yPos
    let { bottomLeft, bottomRight, topLeft, topRight } = this.resizeElement
    let newWidth = width;
    let newHeight = height;
    let ratio = null;
    let pointAround = null
    const { P1, P2, P3, P4 } = getPoints(layer)
    const Pr = {
      x: xPos,
      y: yPos
    }
    if (topLeft) {
      // get distance between parallel lines
      const slope = Math.tan((rotation) * Math.PI / 180 - 45)
      const b0 = -1 * slope * this.mouseStartResizeX + this.mouseStartResizeY
      const b1 = -1 * slope * clientX + clientY
      let dist =100/this.zoom * Math.abs(b1 - b0) / Math.sqrt(Math.pow(slope, 2) + 1)
      // check if point is above f(x) or not
      const beta = Math.atan(width / height) //+ Math.PI * (rotation) / 180
      const alpha = Math.PI / 2 - beta
      if (alpha + rotation * Math.PI / 180 > Math.PI || alpha + rotation * Math.PI / 180 < 0) {
        if (slope * clientX - slope * this.mouseStartResizeX + this.mouseStartResizeY > clientY) {
          dist = dist * -1
        }
      } else {
        if (slope * clientX - slope * this.mouseStartResizeX + this.mouseStartResizeY < clientY) {
          dist = dist * -1
        }
      }
      const heightToAdd = dist * Math.sin(alpha) / Math.cos(Math.PI / 4 - beta)
      ratio = (height + heightToAdd) / height
      // update layer size
      newHeight = height * ratio
      newWidth = width * ratio
      const P1rotated = rotatePoint(rotation, Pr, P1)
      const P4rotated = rotatePoint(rotation, Pr, P4)
      const newP1ScaledPoint = scalePoint(ratio, P4rotated, P1rotated)
      const newCenterPoint = scalePoint(ratio, P4rotated, P1rotated)
      const newP1 = rotatePoint(-1 * rotation, newCenterPoint, newP1ScaledPoint)
      const newOrigin = { x: newP1.x, y: newP1.y }
      // offset
      xPosNew = newOrigin.x - P1.x + xPos
      yPosNew = newOrigin.y - P1.y + yPos
      xCropNew = xCropNew * ratio
      yCropNew = yCropNew * ratio
      pointAround = P4rotated
    } else if (topRight) {
      const slope = Math.tan((rotation) * Math.PI / 180 + 45)
      const b0 = -1 * slope * this.mouseStartResizeX + this.mouseStartResizeY
      const b1 = -1 * slope * clientX + clientY
      let dist = 100/this.zoom * Math.abs(b1 - b0) / Math.sqrt(Math.pow(slope, 2) + 1)
      // check if point is above f(x) or not
      const beta = Math.atan(width / height)  //+ Math.PI * (rotation) / 180
      let alpha = Math.PI / 2 - beta
      if (beta + rotation * Math.PI / 180 > Math.PI / 2 || beta + rotation * Math.PI / 180 < -3 * Math.PI / 4 ) {
        if (slope * clientX - slope * this.mouseStartResizeX + this.mouseStartResizeY > clientY) {
          dist = dist * -1
        }
      } else {
        if (slope * clientX - slope * this.mouseStartResizeX + this.mouseStartResizeY < clientY) {
          dist = dist * -1
        }
      }
      const heightToAdd = dist * Math.sin(alpha) / Math.cos(Math.PI / 4 - beta)
      // update layer size
      ratio = (height + heightToAdd) / height
      newHeight = height * ratio
      newWidth = width * ratio
      const P2rotated = rotatePoint(rotation, Pr, P2)
      const P3rotated = rotatePoint(rotation, Pr, P3)
      const newP2ScaledPoint = scalePoint(ratio, P3rotated, P2rotated)
      const newP1ScaledPoint = scalePoint(ratio, P3rotated, P1)
      const newCenterPoint = newP1ScaledPoint;
      const newP2 = rotatePoint(-1 * rotation, newCenterPoint, newP2ScaledPoint)
      const newOrigin = { x: newP2.x - width * ratio, y: newP2.y }
      // offset
      xPosNew = newOrigin.x - P1.x + xPos
      yPosNew = newOrigin.y - P1.y + yPos
      xCropNew = xCropNew * ratio
      yCropNew = yCropNew * ratio
      pointAround = P3rotated
    } else if (bottomLeft) {
      const slope = Math.tan((rotation) * Math.PI / 180 + 45)
      const b0 = -1 * slope * this.mouseStartResizeX + this.mouseStartResizeY
      const b1 = -1 * slope * clientX + clientY
      let dist = 100/this.zoom * Math.abs(b1 - b0) / Math.sqrt(Math.pow(slope, 2) + 1)
      const beta = Math.atan(width / height)
      let alpha = Math.PI / 2 - beta
      // check if point is above f(x) or not
      if (beta + rotation * Math.PI / 180 > Math.PI / 2 || beta + rotation * Math.PI / 180 < Math.PI / -2) {
        if (slope * clientX - slope * this.mouseStartResizeX + this.mouseStartResizeY < clientY) {
          dist = dist * -1
        }
      } else {
        if (slope * clientX - slope * this.mouseStartResizeX + this.mouseStartResizeY > clientY) {
          dist = dist * -1
        }
      }
      const heightToAdd = dist * Math.sin(alpha) / Math.cos(Math.PI / 4 - beta)
      // update layer size
      ratio = (height + heightToAdd) / height
      newHeight = height * ratio
      newWidth = width * ratio
      const P2rotated = rotatePoint(rotation, Pr, P2)
      const P3rotated = rotatePoint(rotation, Pr, P3)
      const newP3ScaledPoint = scalePoint(ratio, P2rotated, P3rotated)
      const newP1ScaledPoint = scalePoint(ratio, P2rotated, P1)
      const newCenterPoint = newP1ScaledPoint
      const newP3 = rotatePoint(-1 * rotation, newCenterPoint, newP3ScaledPoint)
      const newOrigin = { x: newP3.x, y: newP3.y - height * ratio}
      // offset
      xPosNew = newOrigin.x - P1.x + xPos
      yPosNew = newOrigin.y - P1.y + yPos
      xCropNew = xCropNew * ratio
      yCropNew = yCropNew * ratio
      pointAround = P2rotated
    } else if (bottomRight) {
      const slope = Math.tan((rotation) * Math.PI / 180 -45)
      const b0 = -1 * slope * this.mouseStartResizeX + this.mouseStartResizeY
      const b1 = -1 * slope * clientX + clientY
      let dist = 100/this.zoom * Math.abs(b1 - b0) / Math.sqrt(Math.pow(slope, 2) + 1)
      const beta = Math.atan(width / height)
      const alpha = Math.PI / 2 - beta
      if (alpha + rotation * Math.PI / 180 > Math.PI || alpha + rotation * Math.PI / 180 < 0) {
        if (slope * clientX - slope * this.mouseStartResizeX + this.mouseStartResizeY < clientY) {
          dist = dist * -1
        }
      } else {
        if (slope * clientX - slope * this.mouseStartResizeX + this.mouseStartResizeY > clientY) {
          dist = dist * -1
        }
      }
      const heightToAdd = dist * Math.sin(alpha) / Math.cos(Math.PI / 4 - beta)
      ratio = (height + heightToAdd) / height
      // update layer size
      newHeight = height * ratio
      newWidth = width * ratio
      const P1rotated = rotatePoint(rotation, Pr, P1)
      const P4rotated = rotatePoint(rotation, Pr, P4)
      const newP4ScaledPoint = scalePoint(ratio, P1rotated, P4rotated)
      const newCenterPoint = P1
      const newP1 = rotatePoint(-1 * rotation, newCenterPoint, newP4ScaledPoint)
      const newOrigin = { x: newP1.x - width * ratio, y: newP1.y - height * ratio}
      // offset
      xPosNew = newOrigin.x - P1.x + xPos
      yPosNew = newOrigin.y - P1.y + yPos
      xCropNew = xCropNew * ratio
      yCropNew = yCropNew * ratio
      pointAround = P1rotated
    }
    // scale and reposition all layers within group
    if (groupLayers && ratio && pointAround) {
      groupLayers.forEach(l => {
        this.scaleGroupLayer(l, ratio, pointAround)
      })
    }
    return {
      xPosNew,
      yPosNew,
      newHeight,
      newWidth,
      xCropNew,
      yCropNew,
    }
  }

  calculateCroppedImageDimensions(layer, clientX, clientY, altDown) {
    const {
      xPos, 
      yPos,
      xCrop,
      yCrop,
      rotation,
      frameWidth,
      frameHeight,
      displayHeight,
      displayWidth,
      originalDisplayWidth,
      originalDisplayHeight } = layer
    let xPosNew = xPos || 0
    let yPosNew = yPos || 0
    let xCropNew = xCrop || 0
    let yCropNew = yCrop || 0
    let frameWidthNew = frameWidth
    let frameHeightNew = frameHeight
    let displayHeightNew = displayHeight
    let displayWidthNew = displayWidth
    let newOriginalWidth = originalDisplayWidth
    let newOriginalHeight = originalDisplayHeight
    let totalMoveX = clientX - this.mouseStartResizeX 
    let totalMoveY = clientY - this.mouseStartResizeY 
    if(layer.type === 'text'){
      const zoom = this.zoom / 100
      if(zoom <= 1){
        totalMoveX *= zoom
        totalMoveY *= zoom
      }
    }
    const {
      left,
      right,
      top,
      bottom
    } = this.resizeBarElement
    let ratio =1
    // get move distance and angle
    const shiftLength = Math.sqrt(Math.pow(totalMoveX, 2) + Math.pow(totalMoveY, 2))
    const dragAngle = Math.atan2(totalMoveY, totalMoveX);
    // project distance to vector in the direction of layer rotation
    const cx = 100/this.zoom * shiftLength * Math.sin((Math.PI * (rotation) / 180) - dragAngle - Math.PI/2)
    const cy = 100 / this.zoom * shiftLength * Math.sin(dragAngle - (Math.PI * (rotation) / 180) - Math.PI)
    if ((left || right) && altDown) {
      displayWidthNew = cx + displayWidth
      frameWidthNew = cx + frameWidth
      frameHeightNew = cx * frameHeight / frameWidth + frameHeight
      ratio = displayWidthNew / displayWidth
      const newP1 = layer.type === "element" ?
        this.transformPointForBarResizeElement("horizontal", layer, ratio, rotation) :
        this.transformPointForBarResize("horizontal", layer, ratio, rotation)
      displayWidthNew += cx
      xPosNew = newP1.x
      yPosNew = newP1.y
      xCropNew = (cx + xCrop < 0) ? (cx + xCrop) : 0;
      if (Math.round(frameWidthNew) === Math.round(displayWidthNew)) {
        xCropNew = 0
      }
    } else if ((top || bottom) && altDown) {
      displayHeightNew = cy + displayHeight
      frameHeightNew = cy + frameHeight
      frameWidthNew = cy * frameWidth / frameHeight + frameWidth
      ratio = displayHeightNew / displayHeight
      const P1 = {
        x: xPos, y: yPos
      }
      const newP1 = layer.type === "element" ?
        this.transformPointForBarResizeElement("vertical", layer, ratio, rotation) :
        this.transformPointForBarResize("vertical", layer, ratio, rotation)
      displayHeightNew += cy
      xPosNew = newP1.x
      yPosNew = newP1.y
      yCropNew = (cy + yCrop < 0) ? (cy + yCrop) : 0
      if (Math.round(frameHeightNew) === Math.round(displayHeightNew)) {
        yCropNew = 0
      }
    } else if (left) {
      displayWidthNew = cx + displayWidth
      frameWidthNew = cx + frameWidth
      frameHeightNew = cx * frameHeight / frameWidth + frameHeight
      ratio = (cx + displayWidth) / displayWidth
      const newP1 = layer.type === "element" ?
        this.transformPointForBarResizeElement("left", layer, ratio, rotation) :
        this.transformPointForBarResize("left", layer, ratio, rotation)
      xPosNew = newP1.x
      yPosNew = newP1.y
      xCropNew = (cx + xCrop < 0) ? (cx + xCrop) : 0;
      if (Math.round(frameWidthNew) === Math.round(displayWidthNew)) {
        xCropNew = 0
      }
    } else if (right) {
      displayWidthNew = cx * -1 + displayWidth
      frameWidthNew = cx * -1 + frameWidth
      frameHeightNew = cx * -1 * frameHeight / frameWidth + frameHeight
      ratio = (cx + displayWidth) / displayWidth
      // layer corner coords
      const P1 = {
        x: xPos, y: yPos
      }
      const newP2 = layer.type === "element" ?
        this.transformPointForBarResizeElement("right", layer, ratio, rotation) :
        this.transformPointForBarResize("right", layer, ratio, rotation)
      const newOrigin = {x: newP2.x - displayWidth*ratio, y: newP2.y}
      yPosNew = P1.y - newOrigin.y + yPos
      xPosNew = P1.x - newOrigin.x + xPos
    }
    else if (top) {
      displayHeightNew = cy + displayHeight
      frameHeightNew = cy + frameHeight
      frameWidthNew = cy * frameWidth / frameHeight + frameWidth
      ratio = (cy + displayHeight) / displayHeight
      const newP1 = layer.type === "element" ?
        this.transformPointForBarResizeElement("top", layer, ratio, rotation) :
        this.transformPointForBarResize("top", layer, ratio, rotation)
      xPosNew = newP1.x
      yPosNew = newP1.y
      yCropNew = (cy + yCrop < 0) ? (cy + yCrop) : 0
      if (Math.round(frameHeightNew) === Math.round(displayHeightNew)) {
        yCropNew = 0
      }
    }
    else if (bottom) {
      displayHeightNew = cy * -1 + displayHeight
      frameHeightNew = cy * -1 + frameHeight
      frameWidthNew = cy * -1 * frameWidth / frameHeight + frameWidth
      ratio = (cy + displayHeight) / displayHeight
      // layer corner coords
      const P1 = {
        x: xPos, y: yPos
      }
      const newP4 = layer.type === "element" ?
        this.transformPointForBarResizeElement("bottom", layer, ratio, rotation) :
        this.transformPointForBarResize("bottom", layer, ratio, rotation)
      const newOrigin = { x: newP4.x - displayWidth, y: newP4.y - displayHeight * ratio }
      yPosNew = P1.y - newOrigin.y + yPos
      xPosNew = P1.x - newOrigin.x + xPos
    }
    // only resize frame size if display rect leaves frame rect (frame size + crop)
    if ((left || right) && altDown) {
      if (frameWidthNew > frameWidth) {
        if (frameWidthNew + xCropNew > displayWidthNew) {
          frameWidthNew = frameWidth
          frameHeightNew = frameHeight
        } else if (frameWidthNew + xCropNew < displayWidthNew) {
          frameWidthNew = displayWidthNew
          frameHeightNew = frameHeight / frameWidth * frameWidthNew
        }
      } else {
        frameWidthNew = frameWidth
        frameHeightNew = frameHeight
      }
    } else if ((top || bottom) && altDown) {
      if (frameHeightNew > frameHeight) {
        if (frameHeightNew + yCropNew > displayHeightNew) {
          frameWidthNew = frameWidth
          frameHeightNew = frameHeight
        } else if (frameHeightNew + yCropNew < displayHeightNew) {
          frameHeightNew = displayHeightNew
          frameWidthNew = frameWidth / frameHeight * frameHeightNew
          // displayHeightNew = frameHeightNew + yCropNew
        }
      } else {
        frameWidthNew = frameWidth
        frameHeightNew = frameHeight
      }
    } else if (left) {
      if (frameWidthNew > frameWidth) {
        if (xCropNew < 0) {
          frameWidthNew = frameWidth
          frameHeightNew = frameHeight
        } else {
          // nothing
        }
      } else {
        frameWidthNew = frameWidth
        frameHeightNew = frameHeight
      }
    } else if (right) {
      if (frameWidthNew > frameWidth) {
        if (frameWidthNew + xCropNew > displayWidthNew) {
          frameWidthNew = frameWidth
          frameHeightNew = frameHeight
        } else if (frameWidthNew + xCropNew < displayWidthNew) {
          // displayWidthNew = frameWidthNew + xCropNew
          frameWidthNew = displayWidthNew + -1* xCropNew
          frameHeightNew = frameHeight / frameWidth * frameWidthNew
        }
      } else {
        frameWidthNew = frameWidth
        frameHeightNew = frameHeight
      }
    } else if (top) {
      if (frameHeightNew > frameHeight) {
        if (yCropNew < 0) {
          frameWidthNew = frameWidth
          frameHeightNew = frameHeight
        } else {
          // nothing
        }
      } else {
        frameWidthNew = frameWidth
        frameHeightNew = frameHeight
      }
    } else if (bottom) {
      if (frameHeightNew > frameHeight) {
        if (frameHeightNew + yCropNew > displayHeightNew) {
          frameWidthNew = frameWidth
          frameHeightNew = frameHeight
        } else if (frameHeightNew + yCropNew < displayHeightNew) {
          // displayHeightNew = frameHeightNew + yCropNew
          frameHeightNew = displayHeightNew + -1* yCropNew
          frameWidthNew = frameWidth / frameHeight * frameHeightNew
        }
      } else {
        frameWidthNew = frameWidth
        frameHeightNew = frameHeight
      }
    }
    return {
      xPosNew,
      yPosNew,
      xCropNew,
      yCropNew,
      frameWidthNew,
      frameHeightNew,
      displayHeightNew,
      newOriginalHeight,
      newOriginalWidth,
      displayWidthNew
    }
  }

  transformPointForBarResize(handle, layer, ratio, rotation) {
    const {P1, P2, P3, P4} = getPoints(layer)
    if (handle === "horizontal") {
      const Pr = this.calcCenter(P1, P4)
      const P1rotated = rotatePoint(rotation, Pr, P1)
      const P2rotated = rotatePoint(rotation, Pr, P2)
      const P3rotated = rotatePoint(rotation, Pr, P3)
      const P4rotated = rotatePoint(rotation, Pr, P4)
      const newP1ScaledPoint = scalePoint(ratio, P2rotated, P1rotated)
      const newP4ScaledPoint = scalePoint(ratio, P3rotated, P4rotated)
      const newCenterPoint = scalePoint(1 / 2, newP4ScaledPoint, newP1ScaledPoint)
      const newP1 = rotatePoint(
        -1 * rotation,
        newCenterPoint,
        newP1ScaledPoint
      )
      return newP1
    } else if (handle === "vertical") {
      const Pr = this.calcCenter(P1, P4)
      const P1rotated = rotatePoint(rotation, Pr, P1)
      const P2rotated = rotatePoint(rotation, Pr, P2)
      const P3rotated = rotatePoint(rotation, Pr, P3)
      const P4rotated = rotatePoint(rotation, Pr, P4)
      const newP1ScaledPoint = scalePoint(ratio, P3rotated, P1rotated)
      const newP4ScaledPoint = scalePoint(ratio, P2rotated, P4rotated)
      const newCenterPoint = scalePoint(1 / 2, newP4ScaledPoint, newP1ScaledPoint)
      const newP1 = rotatePoint(
        -1 * rotation,
        newCenterPoint,
        newP1ScaledPoint
      )
      return newP1
    } else if (handle === "left") {
      const Pr = this.calcCenter(P1, P4)
      const P1rotated = rotatePoint(rotation, Pr, P1)
      const P2rotated = rotatePoint(rotation, Pr, P2)
      const P4rotated = rotatePoint(rotation, Pr, P4)
      const newP1ScaledPoint = scalePoint(ratio, P2rotated, P1rotated)
      const newCenterPoint = scalePoint(1 / 2, P4rotated, newP1ScaledPoint)
      const newP2 = rotatePoint(
        -1 * rotation,
        newCenterPoint,
        newP1ScaledPoint
      )
      return newP2
    } else if (handle === "right") {
      const Pr = this.calcCenter(P1, P4)
      const P1rotated = rotatePoint(rotation, Pr, P1)
      const P2rotated = rotatePoint(rotation, Pr, P2)
      const P3rotated = rotatePoint(rotation, Pr, P3)
      const newP2ScaledPoint = scalePoint(ratio, P1rotated, P2rotated)
      const newCenterPoint = scalePoint(1 / 2, P3rotated, newP2ScaledPoint)
      const newP2 = rotatePoint(
        -1 * rotation,
        newCenterPoint,
        newP2ScaledPoint
      )
      return newP2
    } else if (handle === "top") {
      const Pr = this.calcCenter(P1, P4)
      const P1rotated = rotatePoint(rotation, Pr, P1)
      const P3rotated = rotatePoint(rotation, Pr, P3)
      const P4rotated = rotatePoint(rotation, Pr, P4)
      const newP1ScaledPoint = scalePoint(ratio, P3rotated, P1rotated)
      const newCenterPoint = scalePoint(1 / 2, P4rotated, newP1ScaledPoint)
      const newP1 = rotatePoint(
        -1 * rotation,
        newCenterPoint,
        newP1ScaledPoint
      )
      return newP1
    } else if (handle === "bottom") {
      const Pr = this.calcCenter(P1, P4)
      const P1rotated = rotatePoint(rotation, Pr, P1)
      const P2rotated = rotatePoint(rotation, Pr, P2)
      const P4rotated = rotatePoint(rotation, Pr, P4)
      const newP4ScaledPoint = scalePoint(ratio, P2rotated, P4rotated)
      const newCenterPoint = scalePoint(1 / 2, P1rotated, newP4ScaledPoint)
      const newP4 = rotatePoint(
        -1 * rotation,
        newCenterPoint,
        newP4ScaledPoint
      )
      return newP4
    }
  }


  transformPointForBarResizeElement(handle, layer, ratio, rotation) {
    const { P1, P2, P3, P4 } = getPoints(layer)
    const Pr = {
      x: P1.x,
      y: P1.y
    }
    if (handle === "horizontal") {
      const P2rotated = rotatePoint(rotation, Pr, P2)
      const newP1ScaledPoint = scalePoint(ratio, P2rotated, P1)
      return newP1ScaledPoint
    } else if (handle === "vertical") {
      const P1rotated = rotatePoint(rotation, Pr, P1)
      const P3rotated = rotatePoint(rotation, Pr, P3)
      const newP1ScaledPoint = scalePoint(ratio, P3rotated, P1rotated)
      return newP1ScaledPoint
    } else if (handle === "left") {
      const P1rotated = rotatePoint(rotation, Pr, P1)
      const P2rotated = rotatePoint(rotation, Pr, P2)
      const newP1ScaledPoint = scalePoint(ratio, P2rotated, P1rotated)
      const newCenterPoint = newP1ScaledPoint
      const newP1 = rotatePoint(
        -1 * rotation,
        newCenterPoint,
        newP1ScaledPoint
      )
      return newP1
    } else if (handle === "right") {
      const P1rotated = rotatePoint(rotation, Pr, P1)
      const P2rotated = rotatePoint(rotation, Pr, P2)
      const newP2ScaledPoint = scalePoint(ratio, P1rotated, P2rotated)
      const newCenterPoint = P1rotated
      const newP2 = rotatePoint(
        -1 * rotation,
        newCenterPoint,
        newP2ScaledPoint
      )
      return newP2
    } else if (handle === "top") {
      const P1rotated = rotatePoint(rotation, Pr, P1)
      const P3rotated = rotatePoint(rotation, Pr, P3)
      const newP1ScaledPoint = scalePoint(ratio, P3rotated, P1rotated)
      const newCenterPoint = newP1ScaledPoint
      const newP1 = rotatePoint(
        -1 * rotation,
        newCenterPoint,
        newP1ScaledPoint
      )
      return newP1
    } else if (handle === "bottom") {
      const P1rotated = rotatePoint(rotation, Pr, P1)
      const P2rotated = rotatePoint(rotation, Pr, P2)
      const P4rotated = rotatePoint(rotation, Pr, P4)
      const newP4ScaledPoint = scalePoint(ratio, P2rotated, P4rotated)
      const newCenterPoint = P1rotated
      const newP4 = rotatePoint(
        -1 * rotation,
        newCenterPoint,
        newP4ScaledPoint
      )
      return newP4
    }
  }
/**
 * Get the arithmetic average of two points
 * @param {Object} P1 point, {x, y}
 * @param {Object} P2 point. {x, y}
 * @returns the arithmetic average of P1 and P2
 */
  calcCenter(P1, P2) {
    return {x: (P1.x + P2.x)/2, y: (P1.y + P2.y)/2}
  }
  /**
   * resets all guidelines
   */
  resetGuidelines() {
    this.guidelines = []
  }
/**
 * toggle snap
 */
  toggleSnap() {
    this.snapEnabled = !this.snapEnabled
  }
  
/**
 * calculates all layer corner coords
 * @param {array} layers array of layers
 * @param {boolean} includeCenter include center point?
 * @param {boolean} includeEdges include edge center points?
 * @param {Array} frameToInclude Array containing the frame's top left and bottom right corner
 * @returns {x: [float], y: [float]}
 */
  calculateAllPositions(layers, includeCenter = true, includeEdges = false, frameToInclude = null) {
    const layerPositions = layers.map((l) => {
      const P1 = { x: l.xPos, y: l.yPos }
      const P2 = { x: l.xPos + l.displayWidth, y: l.yPos }
      const P3 = { x: l.xPos, y: l.yPos + l.displayHeight }
      const P4 = { x: l.xPos + l.displayWidth, y: l.yPos + l.displayHeight }
      const Pr = {
        x: l.xPos + l.displayWidth / 2,
        y: l.yPos + l.displayHeight / 2,
      }
      const Points = [P1, P2, P3, P4]
      return {
        Points: Points,
        Pr: Pr,
        rotation: l.rotation,
        type: l.type,
      }
    })
    if (includeEdges) {
      layerPositions.forEach((f) =>
        f.Points.push(
          this.calcCenter(f.Points[0], f.Points[1]),
          this.calcCenter(f.Points[1], f.Points[3]),
          this.calcCenter(f.Points[2], f.Points[3]),
          this.calcCenter(f.Points[0], f.Points[2])
        )
      )
    }
    // transform positions to screen coordinates
    const screenCoordinates = layerPositions.map((p) => {
      const RotatedPoints = p.Points.map((m) =>
      {
        if (p.type === "element") {
          return rotatePoint(p.rotation, p.Points[0], m)
        } else {
          return rotatePoint(p.rotation, p.Pr, m)
        }
      }
      )
      if (includeCenter) {
        if (p.type === "element") {
          const P4rotated = rotatePoint(p.rotation, p.Points[0], p.Points[3])
          const Pr = scalePoint(0.5, p.Points[0], P4rotated)
          RotatedPoints.push(Pr)
        } else {
          RotatedPoints.push(p.Pr)
        }
        
      }
      return {
        RotatedPoints,
      }
    })
    // flatten arrays
    let flatArrays = {
      x: screenCoordinates.map((m) => m.RotatedPoints.map((rp) => rp.x)).flat(),
      y: screenCoordinates.map((m) => m.RotatedPoints.map((rp) => rp.y)).flat(),
    }
    if (frameToInclude) {
      flatArrays.x = flatArrays.x.concat(frameToInclude.map(m=>m.x))
      flatArrays.y = flatArrays.y.concat(frameToInclude.map(m=>m.y))
    }
    return flatArrays
  }

  calculateGroupDimensions(layers) {
    const flatArrays = this.calculateAllPositions(layers)
    const minX = Math.min.apply(Math, flatArrays.x)
    const minY = Math.min.apply(Math, flatArrays.y)
    const maxX = Math.max.apply(Math, flatArrays.x)
    const maxY = Math.max.apply(Math, flatArrays.y)
    
    const xPos = minX
    const yPos = minY
    const groupHeight = maxY - minY
    const groupWidth = maxX - minX
    return {
      xPos,
      yPos,
      groupHeight,
      groupWidth
    }
  }

  //ClientY not used right now. Ideally resizing should take place on both X and Y axis
  resizeLayer(clientX, clientY, offsetX, offsetY, layer, setMousePos = true){
    if(!this.resizingLayer){
      return
    }
    const { displayHeight, displayWidth, frameHeight, size, frameWidth, type, id } = layer
 
    if(type === 'text'){
      const { newHeight, newWidth, yCropNew, xCropNew, xPosNew, yPosNew } = this.calculateImageDimensions(displayHeight, displayWidth, clientX, clientY, layer)
      const diff = newWidth / displayWidth
      if(frameHeight !== displayHeight || frameWidth !== displayWidth){  
        layer.frameHeight *= diff
        layer.frameWidth *= diff
        layer.originalDisplayHeight = layer.frameHeight
        layer.originalDisplayWidth = layer.frameWidth
      }else{
        layer.frameHeight = newHeight
        layer.frameWidth = newWidth
        layer.originalDisplayWidth = newWidth
        layer.originalDisplayHeight = newHeight
      }
      layer.size = layer.size * diff;
      layer.displayHeight = newHeight
      layer.displayWidth = newWidth
      layer.xCrop = xCropNew
      layer.yCrop = yCropNew
      layer.xPos = xPosNew
      layer.yPos = yPosNew
      this.resizeTextLayer(id)
      if(setMousePos){
        this.mouseStartResizeX = clientX
        this.mouseStartResizeY = clientY
      }
    } else if (type === 'group') {
      const layers = this.getAllLayers()
      const groupLayers = layers.filter(l => layer.layers.includes(l.id))
      const { newHeight, newWidth, yCropNew, xCropNew, xPosNew, yPosNew } =
        this.calculateImageDimensions(displayHeight, displayWidth, clientX, clientY, layer, groupLayers)
      if(frameHeight !== displayHeight || frameWidth !== displayWidth){
        const diff = newWidth / displayWidth
        layer.frameHeight *= diff
        layer.frameWidth *= diff
        layer.originalDisplayHeight = layer.frameHeight
        layer.originalDisplayWidth = layer.frameWidth
      }else{
        layer.frameHeight = newHeight
        layer.frameWidth = newWidth
        layer.originalDisplayWidth = newWidth
        layer.originalDisplayHeight = newHeight
      }
      layer.displayHeight = newHeight
      layer.displayWidth = newWidth
      layer.xCrop = xCropNew
      layer.yCrop = yCropNew
      layer.xPos = xPosNew
      layer.yPos = yPosNew
      this.mouseStartResizeX = clientX
      this.mouseStartResizeY = clientY
    } else if (type === 'svg'){
      const { newHeight, newWidth, yCropNew, xCropNew, xPosNew, yPosNew } = this.calculateImageDimensions(displayHeight, displayWidth, clientX, clientY, layer)
      const heightDiff = newHeight - layer.displayHeight
      const widthDiff = newWidth - layer.displayWidth
      const xDiff = layer.xPos - xPosNew
      const yDiff = layer.yPos - yPosNew 
      layer.frameHeight = newHeight
      layer.frameWidth = newWidth
      layer.displayHeight = newHeight
      layer.displayWidth = newWidth
      layer.xCrop = xCropNew
      layer.yCrop = yCropNew
      layer.xPos = xPosNew
      layer.yPos = yPosNew
      layer.boxWidth += widthDiff
      layer.boxHeight += heightDiff
      this.mouseStartResizeX = clientX
      this.mouseStartResizeY = clientY
    } else {
      const { newHeight, newWidth, yCropNew, xCropNew, xPosNew, yPosNew } = this.calculateDimensions(displayHeight, displayWidth, clientX, clientY, layer)
      const diff = newWidth / displayWidth
      if(frameHeight !== displayHeight || frameWidth !== displayWidth){  
        layer.frameHeight *= diff
        layer.frameWidth *= diff
        layer.originalDisplayHeight = layer.frameHeight
        layer.originalDisplayWidth = layer.frameWidth
      }else{
        layer.frameHeight = newHeight
        layer.frameWidth = newWidth
        layer.originalDisplayWidth = newWidth
        layer.originalDisplayHeight = newHeight
      }
      layer.displayHeight = newHeight
      layer.displayWidth = newWidth
      layer.xCrop = xCropNew
      layer.yCrop = yCropNew
      layer.xPos = xPosNew
      layer.yPos = yPosNew
      if(setMousePos){
        this.mouseStartResizeX = clientX
        this.mouseStartResizeY = clientY
      }
    }
  }

  resizeLayerBar(clientX, clientY, offsetX, offsetY, layer, altDown = false){
    if(!this.resizingLayerBar){
      return
    }
    if(layer.type === 'text'){
      const { 
        xCropNew, yCropNew,
        xPosNew, yPosNew,
        displayHeightNew, displayWidthNew, 
        newOriginalHeight
      } = this.calculateCroppedImageDimensions(layer, clientX, clientY, altDown)
      layer.editorHeight = displayHeightNew
      layer.editorWidth = displayWidthNew
      layer.frameWidth = displayWidthNew
      layer.displayWidth = displayWidthNew
      layer.originalDisplayHeight = newOriginalHeight
      layer.xCrop = xCropNew
      layer.yCrop = yCropNew
      layer.xPos = xPosNew
      layer.yPos = yPosNew
      this.resizeTextLayer(layer.id)
    }
    if(layer.type === 'element'){
      const {
        xPosNew, yPosNew,
        xCropNew, yCropNew,
        displayHeightNew, displayWidthNew,
        frameWidthNew, frameHeightNew,
        newOriginalHeight, newOriginalWidth
      } = this.calculateCroppedImageDimensions(layer, clientX, clientY, altDown)
      layer.xPos = xPosNew
      layer.yPos = yPosNew
      layer.xCrop = xCropNew
      layer.yCrop = yCropNew
      layer.frameWidth = frameWidthNew
      layer.frameHeight = frameHeightNew
      layer.displayHeight = displayHeightNew
      layer.displayWidth = displayWidthNew
      layer.originalDisplayHeight = newOriginalHeight
      layer.originalDisplayWidth = newOriginalWidth
    }else{
      const {
        xPosNew, yPosNew,
        xCropNew, yCropNew,
        displayHeightNew, displayWidthNew,
        frameWidthNew, frameHeightNew,
        newOriginalHeight, newOriginalWidth
      } = this.calculateCroppedImageDimensions(layer, clientX, clientY, altDown)
      layer.xPos = xPosNew
      layer.yPos = yPosNew
      layer.xCrop = xCropNew
      layer.yCrop = yCropNew
      layer.frameWidth = frameWidthNew
      layer.frameHeight = frameHeightNew
      layer.displayHeight = displayHeightNew
      layer.displayWidth = displayWidthNew
      layer.originalDisplayHeight = newOriginalHeight
      layer.originalDisplayWidth = newOriginalWidth
    }
    this.mouseStartResizeX = clientX
    this.mouseStartResizeY = clientY
  }

  /**
  * pointaround - {x, y} point that stays fixed when scaling group
  */
  scaleGroupLayer(layer, ratio, pointAround) {
    const {
      type,
      xPos,
      yPos,
      xCrop,
      yCrop,
      rotation,
      displayWidth,
      displayHeight,
      frameWidth,
      frameHeight
      } = layer
    let xCropNew = xCrop
    let yCropNew = yCrop
    let xPosNew = xPos
    let yPosNew = yPos
    let newWidth = displayWidth;
    let newHeight = displayHeight;
    // update layer size
    newHeight = displayHeight * ratio
    newWidth = displayWidth * ratio
    // layer center coords
    const Pr = {
      x: xPos + displayWidth / 2,
      y: yPos + displayHeight / 2
    }
    // layer corner coords
    const P1 = {
      x: xPos, y: yPos
    }
    const P4 = {
      x: P1.x + displayWidth, y: P1.y + displayHeight
    }
    // scale layer
    const P1rotated = rotatePoint(rotation, Pr, P1)
    const P4rotated = rotatePoint(rotation, Pr, P4)
    // scale layer coordinates to get offset within group
    const newP1Coordinate = scalePoint(ratio, pointAround, P1rotated)
    const newP4Coordinate = scalePoint(ratio, pointAround, P4rotated)
    const newCoordinateCenterPoint = scalePoint(
      1 / 2,
      newP1Coordinate,
      newP4Coordinate
    )
    const newCoordinates = rotatePoint(-1*rotation, newCoordinateCenterPoint, newP1Coordinate)
    // offset
    xPosNew = newCoordinates.x - P1.x + xPos
    yPosNew = newCoordinates.y - P1.y + yPos

    const diff = newWidth / displayWidth
    if(frameHeight !== displayHeight || frameWidth !== displayWidth){
      layer.frameHeight *= diff
      layer.frameWidth *= diff
      layer.originalDisplayHeight = layer.frameHeight
      layer.originalDisplayWidth = layer.frameWidth
    }else{
      layer.frameHeight = newHeight
      layer.frameWidth = newWidth
      layer.originalDisplayWidth = newWidth
      layer.originalDisplayHeight = newHeight
    }
    if (type === "text") {
      layer.size = layer.size * diff;
      this.resizeTextLayer(layer.id)
    }
    layer.displayHeight = newHeight
    layer.displayWidth = newWidth
    layer.xCrop = xCropNew * diff
    layer.yCrop = yCropNew * diff
    layer.xPos = xPosNew
    layer.yPos = yPosNew
  }

  checkAndCloseCropper(){
    if(this.resizingPage){
      this.toggleBackgroundCropper(this.resizingPage, true)
    }
  }

  insertItemDrag(item, x, y){
    this.checkAndCloseCropper()
    const pageCordinates = this.pages.map(p => {
      const el = document.querySelector(`[data-id="${btoa(p.id)}"]`)
      if(el){
        const { x: pageX, y: pageY, width, height } = el.getBoundingClientRect()
        const right = pageX + width
        const bottom = pageY + height
        return {
          pageX, pageY, bottom, right, id: p.id, width, height, originalHeight: p.height, originalWidth: p.width
        }
      }
    })
    let found = false
    let itemId = null
    pageCordinates.forEach((page, idx) => {
      const { right, bottom, id, pageX, pageY, height: pageHeight } = page
      if(bottom > y && right > x && pageX < x && pageY < y && !found){
        const zoom = this.zoom / 100
        const xCords = (x - pageX) / zoom
        const yCords = (y - pageY) / zoom
        itemId = uuidv4()
        const pageIdx = this.pages.findIndex(({ id: pid }) => pid === id)
        switch(item.type){
          case 'photo':
          case 'illustration':
            if(item.parsedSVG){
              this.insertSVGElement(item, page.originalWidth, page.originalHeight, true, xCords, yCords)
              break
            }
            const { urls: { regular: url }, height: originalHeight, width: originalWidth } = item
            const { displayHeight, displayWidth } = this.calculatePhotoSize(originalWidth, page.width / zoom, originalHeight, page.height / zoom)
            const photo = new PhotoElement(
              itemId,
              url,
              displayHeight,
              displayWidth,
              displayHeight,
              displayWidth,
              yCords - (displayHeight / 2),
              xCords - (displayWidth / 2),
              1,
              0,
              0,
              displayWidth,
              displayHeight,
              0,
              displayHeight,
              displayWidth,
              null,
              item.photoType ? item.photoType : null,
              item.frames ? item.frames : null,
              {
                opacity: 100,
                brightness: 100,
                contrast: 100,
                saturation: 100,
                blur: 0
              },
              item.isUpload,
              item.assetId,
              false,
              null,
            )
            this.pages[pageIdx].layers.push(photo)
            found = true
            break
          case 'element':
            const { dataSource, displayWidth: dw, displayHeight: dh, xCrop, yCrop, originX, originY, fillHex, frameHeight, frameWidth, width, height } = item
            const objectX = xCords - (dw / 2)
            const objectY = yCords - (dw / 2)
            const element = new Element(
              itemId,
              dataSource,
              height,
              width,
              height,
              width,
              dh,
              dw,
              objectY,
              objectX,
              xCrop,
              yCrop,
              1,
              1,
              fillHex,
              0,
              null,
              null,
              item.name,
              {
                x: 1,
                y: 1,
                z: 1
              },
              originX || 'left',
              originY || 'top'
            )
            this.pages[pageIdx].layers.push(element)
            found = true
            break
          case 'text':
            let idh = item.displayHeight || 0
            if(item.groupId && item.elements){
              item.elements.forEach(el => {
                idh += el.displayHeight + 10
              })
            }
            let textY = yCords - (idh / 2)
            if(textY + idh >= pageHeight / zoom - 10){
              textY = (pageHeight / zoom - 20) - idh
            }
            let idw = item.displayWidth
            if(item.groupId && item.elements){
              const widths = item.elements.map(el => el.displayWidth)
              idw = Math.max(...widths)
            }
            const textX = xCords - (idw / 2)
            this.insertTextToPage(item, textX, textY, pageIdx, false, true)
            break
          default:
            break
        }
      }
    })
    if(found && itemId){
      this.appendToHistory()
      this.setChanged(true)
      this.selectLayer(itemId)
    }
  }

  selectLayer(layerId){
    const layers = []
    let page
    this.pages.forEach(p => {
      const list = p.layers.map(({ id }) => id)
      if(list.includes(layerId)){
        page = p
      }
      layers.push(...p.layers)
    })
    this.fontSelect = false
    this.selectedLayer = null;
    let groupId = null
    layers.forEach(layer => {
      if(layer.type === 'text'){
        layer.content = layer.content.trim()
      }
      if (layerId === layer.id) {
        if(!layer.groupId){
          layer.selected = true
          this.selectedLayer = layerId;
        }else{
          groupId = layer.groupId
        }
      }else{
        layer.selected = false
        if(layer.selected && layer.type === 'text' && layer.content.trim() === ''){
          this.deleteLayerById(layer.id)
        }
      }
    })
    if(groupId){
      const idx = page.layers.findIndex(({ id }) => id === groupId)
      this.selectedLayer = groupId
      page.layers[idx].selected = true
    }
    this.setChanged(true)
  }

  snapCheck(pageIdx, targetLayer) {
    const page = this.pages[pageIdx]
    if (!page || !targetLayer || !this.snapEnabled) {
      return {x: [], y: []}
    }
    let idList = [targetLayer.id]
    if (targetLayer.layers) {
      idList = idList.concat(targetLayer.layers)
    }
    const allLayers = this.pages[pageIdx].layers.filter(
      (f) => !idList.includes(f.id)
    )
    
    const targetLayerPositions = this.calculateAllPositions(
      [targetLayer]
    )
    const allPositions = this.calculateAllPositions(allLayers, true, false, [
      { x: 0, y: 0 },
      { x: page.displayWidth / 2, y: page.displayHeight / 2},
      { x: page.displayWidth, y: page.displayHeight },
    ])
    if (!targetLayerPositions || !allPositions) {
      return
    }
    const { x, y } = this.getSnapVectors(allPositions, targetLayerPositions)
    // return closest snap points
    return {
      x: x.length ? Math.min.apply(Math, x) : 0,
      y: y.length ? Math.min.apply(Math, y) : 0,
    }
  }
  /**
   * adds guidelines if possible
   * @param {int} pageIdx current page index
   * @param {obj} targetLayer layer being manipulated
   * @returns undefined
   */
  guideLineCheck(pageIdx, targetLayer) {
    const page = this.pages[pageIdx]
    if (!page || !targetLayer) {
      return
    }

    let idList = [targetLayer.id]
    if (targetLayer.layers) {
      idList = idList.concat(targetLayer.layers)
    }
    const allLayers = this.pages[pageIdx].layers.filter(
      (f) => !idList.includes(f.id)
    )
    const targetLayerPositions = this.calculateAllPositions(
      [targetLayer]
    )
    const allPositions = this.calculateAllPositions(allLayers, true, false, [
      { x: 0, y: 0 },
      { x: page.displayWidth / 2, y: page.displayHeight / 2},
      { x: page.displayWidth, y: page.displayHeight },
    ])
    if (!targetLayerPositions || !allPositions) {
      return
    }
    const { x, y } = this.getMatchingPositions(
      allPositions,
      targetLayerPositions
    )
    this.guidelines = [{ id: uuidv4(), x: x, y: y, pageId: page.id }]
  }

  /**
   * Returns xy coordinates where target layer's points (center?) and other layers points (center?) align
   * @param {Array} allOtherPositions Array of all layer's, minus target layer's, positions
   * @param {Array} targetLayerPositions Array of target layer's points
   * @returns Object with coordinates: {x: [1,2,3,...], y: [1,2,3,...]}
   */
  getMatchingPositions(allOtherPositions, targetLayerPositions) {
    let xPositions = new Set()
    let yPositions = new Set()
    let range = 20 / (this.zoom / 100);
    if(range > 40){
      range = 40
    }
    allOtherPositions.x.forEach((p) => {
      const roundedValue = Math.round(p);
      const roundedMax = roundedValue + range
      const roundedMin = roundedValue - range
      if (targetLayerPositions.x.some((s) => Math.round(s) >= roundedMin && Math.round(s) <= roundedMax)) {
        xPositions.add(roundedValue)
      }
    });
    allOtherPositions.y.forEach((p) => {
      const roundedValue = Math.round(p);
      const roundedMax = roundedValue + range
      const roundedMin = roundedValue - range
      if (targetLayerPositions.y.some((s) => Math.round(s) >= roundedMin && Math.round(s) <= roundedMax)) {
        yPositions.add(roundedValue)
      }
    });
    return { x: [...xPositions], y: [...yPositions] }
  }
/**
 * Calculates amount to snap target layer x and y to a position that is closer than the threshold
 * @param {Array} allOtherPositions Array of all layer's, minus target layer's, yPositions
 * @param {Array} targetLayerPositions Array of target layer's points
 * @returns Object with x and y amount to snap: {x: [1,2,3,...], y: [1,2,3,...]}
 */
  getSnapVectors(allOtherPositions, targetLayerPositions) {
    let snapLength = 2 / (this.zoom / 100);
    const snapMap = [
      {
        min: 90,
        max: 100,
        value: 2.25
      },
      {
        min: 80,
        max: 90,
        value: 2.5
      },
      {
        min: 70,
        max: 80,
        value: 2.75
      },
      {
        min: 60,
        max: 70,
        value: 3
      },
      {
        min: 50,
        max: 60,
        value: 3.25
      },
      {
        min: 25,
        max: 50,
        value: 3.85
      },
      {
        min: 10,
        max: 25,
        value: 8
      },
    ]
    if(this.zoom <= 100){
      const match = snapMap.find(({ min, max }) => min <= this.zoom && max >= this.zoom)
      if(match){
        snapLength = match.value
      }
    }
    let xDiff = new Set()
    let yDiff = new Set()
    allOtherPositions.x.forEach((p) => {
      targetLayerPositions.x.forEach((s) => {
        if (Math.abs(s - p) < snapLength) {
          // keep sign
          xDiff.add(s - p)
        }
      });
    });
    allOtherPositions.y.forEach((p) => {
      targetLayerPositions.y.forEach((s) => {
        if (Math.abs(s - p) < snapLength) {
          // keep sign
          yDiff.add(s - p)
        }
      });
    });
    return {
      x: [...xDiff],
      y: [...yDiff],
      lastPos: { x: this.mouseStartX, y: this.mouseStartY },
    }
  }
/**
 * translate layer or group by dx and dy
 * @param {Object} layer layer
 * @param {number} dx translate by x
 * @param {number} dy translate by y
 */
  translateLayers(layer, dx, dy) {
    layer.xPos += dx
    layer.yPos += dy
    if (layer.layers) {
      layer.layers.forEach(f => {
        const l = this.getLayer(f)
        l.xPos += dx
        l.yPos += dy
      })
    }
  }

  checkAlignmapValues(id, x, y){
    if(id === this.outofBoundsLayer){
      return
    }
    const { pageIdx, layerIdx } = this.findLayerIdx(id)
    const layer = this.pages[pageIdx].layers[layerIdx]
    if(x !== 0 && layer.alignMap){
      layer.alignMap.x = {
        left: false,
        right: false,
        center: false
      } 
    }
    if(y !== 0 && layer.alignMap) {
      layer.alignMap.y = {
        top: false,
        middle: false,
        bottom: false
      }
    }
  }

  moveLayer(layer, clientX, clientY) {
    //const targetPage = this.pages.find(({ layers }) => layers.includes(layer))
    //const top = document.querySelector(`[data-id="${btoa(targetPage.id)}"]`).offsetTop
    const zoom = this.zoom / 100
    const dx = (clientX - this.mouseStartX) / zoom
    const dy = (clientY - this.mouseStartY) / zoom
    if(layer.type === 'group'){
      const layers = this.getAllLayers()
      const groupLayers = layers.filter(l => layer.layers.includes(l.id))
      groupLayers.forEach(l => {
        l.xPos += dx
        l.yPos += dy
      })
    }
    layer.xPos += dx
    layer.yPos += dy
    const layerPage = this.pages.find(({ layers }) => layers.includes(layer))
    this.mouseStartX = clientX
    this.mouseStartY = clientY
    const layerElement = document.querySelector(`[data-id="${btoa(layer.id)}"]`)
    const pageElement = document.querySelector(`[data-id="${btoa(layerPage.id)}"]`)
    const pageElements = document.querySelectorAll('.workarea__page')
    const yCords = []
    const yMap = []
    pageElements.forEach((p, idx) => {
      const { y, height } = p.getBoundingClientRect()
      yMap.push({
        id: atob(p.getAttribute('data-id')),
        yMin: y,
        yMax: y + height + 25
      })
      yCords.push(y)
    })
    const minY = Math.min(...yCords)
    const maxY = Math.max(...yCords)
    if(!pageElement || !layerElement){
      return
    }
    const { x: pageX, height: pageH, width: pageW } = pageElement.getBoundingClientRect()
    const pageMaxY = maxY + pageH
    const pageMaxX = pageX + pageW
    const { x, y, width, height } = layerElement.getBoundingClientRect()
    const boundsX = pageX > x + width || x > pageMaxX
    const boundsY = minY > y + height || y > pageMaxY
    if(boundsX || boundsY){
      this.outofBoundsLayer = layer.id
    }else{
      this.outofBoundsLayer = null
    }
    this.checkAlignmapValues(layer.id, dx, dy)
    yMap.forEach(el => {
      const p = this.pages.find(({ id }) => id === el.id)
      const ids = p.layers.map(l => l.id)
      const layerMaxY = y + (height / 2)
      const isNewPage = el.yMin < layerMaxY && el.yMax > layerMaxY && !ids.includes(layer.id)
      if(isNewPage){
        this.newLayerPage = el.id
      }
      if(this.newLayerPage === el.id && !isNewPage){
        this.newLayerPage = null
      }
    })
  }

  findLayerIdx(layerId){
    const pageIdx = this.pages.findIndex(({ layers }) => {
      const ids = layers.map(({ id }) => id)
      return ids.includes(layerId)
    })
    if(pageIdx === -1){
      return {
        pageIdx,
        layerIdx: -1
      }
    }
    const layerIdx = this.pages[pageIdx].layers.findIndex(({ id }) => id === layerId)
    return {pageIdx, layerIdx}
  }

  handleTextLayerChange(layerId, value){
    const {pageIdx, layerIdx} = this.findLayerIdx(layerId)
    const layer = this.pages[pageIdx].layers[layerIdx]
    if(value.trim() !== ''){
      value = value.trim()
    }
    if(layerIdx === -1){
      return
    }
    const prevValue = layer.content
    if(prevValue === value){
      return
    }
    layer.content = value
    this.setChanged(true)
  }

  setLastTextColor(value){
    if(!value){
      this.lastTextColor = null
    }else{
      this.lastTextColor = value
    }
  }

  resizeTextLayer(layerId, widthDelta = 0){
    if(!layerId){
      return
    }
    const {pageIdx, layerIdx} = this.findLayerIdx(layerId)
    if(pageIdx === -1){
      return
    }
    const layer = this.pages[pageIdx].layers[layerIdx]
    if(!layer){
      return
    }
    const selector = `.${btoa(layerId)} .ql-editor`
    const editorWrapper = document.querySelector(selector)
    if(!editorWrapper){
      return
    }
    const { offsetHeight } = editorWrapper
    if(!offsetHeight){
      return
    }
    const { width, height } = editorWrapper.getBoundingClientRect()
    if(offsetHeight > layer.displayHeight || offsetHeight < layer.displayHeight){
      layer.displayHeight = offsetHeight
      layer.frameHeight = offsetHeight
      layer.originalDisplayHeight = offsetHeight
      layer.height = offsetHeight
    }
    if(widthDelta){
      layer.displayWidth += widthDelta
      layer.frameWidth += widthDelta
      layer.originalDisplayWidth += widthDelta
      layer.width += widthDelta
    }
    layer.editorHeight = height
    layer.editorWidth = width
  }

  getLayerStyle(layer, outline = false) {
    const { displayHeight, displayWidth, rotation } = layer
    let base = {
      height: displayHeight,
      width: displayWidth,
      transform: `rotate(${rotation}deg)`
    }
    if(layer.type === 'svg'){
      base.height = layer.boxHeight
      base.width = layer.boxWidth
    }
    if(outline){
      base.height += 2
      base.width += 2
      base.transform = `rotate(${rotation}deg)`
    }
    return base
  }

  setPageBackgroundSize(pageId, source, sourceObject){
    const idx = this.pages.findIndex(({ id }) => id === pageId)
    const page = this.pages.find(({ id }) => id === pageId)
    if(sourceObject && sourceObject.assetId){
      this.pages[idx].backgroundId = sourceObject.assetId
    }
    if(sourceObject && !sourceObject.assetId){
      this.pages[idx].backgroundId = null
    }
    const { displayHeight, displayWidth } = page
    if(!source){
      page.backgroundHeight = 0
      page.backgroundWidth = 0
      page.backgroundPosition = {
        x: 0,
        y: 0
      }
      return
    }
    const img = new Image()
    img.src = source
    img.onload = () => {
      const aspectW = img.width / displayWidth
      const aspectH = img.height / displayHeight
      let h = img.height
      let w = img.width
      if(img.width < displayWidth && img.width > img.height){
        h = displayHeight + 20
        w = img.width / aspectH
      }
      if(img.height < displayHeight && img.height > img.width){
        w = displayWidth + 20
        h = img.height / aspectW
      }
      if(img.width < displayWidth && img.height >= displayHeight){
        w = displayWidth + 20
        h = img.height / aspectW
      }
      if(displayHeight > displayWidth){
          h = displayHeight + 20
          w = img.width / aspectH
      }
      if(displayWidth > displayHeight){
        w = displayWidth + 20
        h = img.height / aspectW
      }
      if(img.height < displayHeight || img.width < displayWidth){
        if(img.width > img.height){
          h = displayHeight
          w = img.width / aspectH
          if(w < displayWidth){
            w = displayWidth
            h = img.height / aspectW
          }
        }
        if(img.height > img.width){
          w = displayWidth
          h = img.height / aspectW
          if(h < displayHeight){
            h = displayHeight
            w = img.width / aspectH
          }
        }
      }

      if(img.width > displayWidth && img.height > displayHeight){
        w = img.width
        h = img.height
        if(img.width > img.height){
          h = displayHeight + 20
          w = img.width / aspectH
          if(w < displayWidth){
            w = img.width / aspectW
          }
        }
        if(img.height > img.width){
          w = displayWidth
          h = img.height / aspectW
          if(h < displayHeight){
            h = displayHeight
            w = img.width / aspectH
          }
        }
        if(h < displayHeight || w < displayWidth){
          w = img.width
          h = img.height
        }
      }

      if(displayWidth === displayHeight){
        if(img.width > img.height){
          h = displayHeight
          w = img.width / aspectH
        }
        if(img.height > img.width){
          if(img.height < displayHeight){
            w = displayWidth * 1.1
            h = img.height / aspectW
          }else{
            w = displayWidth
            h = img.height / aspectW
          }
        }
      }
      if(img.width === img.height && displayHeight === displayWidth){
        w = displayWidth
        h = displayHeight
      }
      page.backgroundWidth = w
      page.backgroundHeight = h
      let posX = 0
      let posY = 0
      if(h > displayHeight){
        posY = (displayHeight - h) / 2
      }
      if(w > displayWidth){
        posX = (displayWidth - w) / 2
      }
      page.backgroundPosition = {
        x: posX,
        y: posY
      }
    }
  }

  getDefaultFilters(){
    return {
      opacity: 100,
      brightness: 100,
      contrast: 100,
      saturation: 100,
      blur: 0
    }
  }

  changePageProp(pageId, propName, propValue, propSource = null){
    const page = this.pages.find(({ id }) => id === pageId)
    if(propName === 'layers'){
      return
    }
    if(propName === 'backgroundUrl'){
      this.setPageBackgroundSize(pageId, propValue, propSource)
      page.filters = this.getDefaultFilters()
    }
    if(propName.includes('filters')){
      if(!page.filters){
        page.filters = this.getDefaultFilters()
      }
      const [n, p] = propName.split('|')
      page.filters[p] = Number(propValue)
      this.setChanged(true)
      return
    }
    page[propName] = propValue
    this.setChanged(true)
  }

  changeLayerProp(layerId, propName, propValue){
    const { pageIdx, layerIdx } = this.findLayerIdx(layerId)
    if(pageIdx > -1 && layerIdx > -1){
      const layer = this.pages[pageIdx].layers[layerIdx]
      if(layer && layer.type === 'svg' && propName === 'fillHex'){
        const el = document.createElement('div')
        el.innerHTML = layer.dataSource
        this.changeFill(el, layer.fillHex, propValue)
        this.pages[pageIdx].layers[layerIdx].fillHex = propValue
        this.pages[pageIdx].layers[layerIdx].dataSource = el.innerHTML
      }else{
        this.pages[pageIdx].layers[layerIdx][propName] = propValue
      }
    }
    this.appendToHistory()
  }

  changeTextLayerProp(layerId, propName, propValue){
    const {pageIdx, layerIdx} = this.findLayerIdx(layerId)
    if(propName === 'font'){
      const layers = this.getAllLayers()
      const textLayers = layers.filter(({ type, id }) => type === 'text' && id !== layerId)
      const textFontIds = textLayers.map(({ font }) => btoa(font.id))
      let removeOverlap = false
      let overlap = false
      const layer = layers.find(({ id }) => id === layerId)
      const hashedId = btoa(layer.font.id)
      const newHash = btoa(propValue.id)
      textFontIds.forEach(fontId => {
        if(fontId === hashedId){
          removeOverlap = true
        }
        if(fontId === newHash){
          overlap = true
        }
      })
      if(!removeOverlap && layer.font.id !== 'arial'){
        const selector = `[data-id="${btoa(layer.font.value)}"]`
        const existingFont = document.head.querySelector(selector)
        if(existingFont){
          existingFont.remove()
        }
      }
      if(!overlap){
        this.appendFont(propValue)
      }
    }
    if(propName === 'lineHeight'){
      setTimeout(() => {
        this.resizeTextLayer(layerId)
      }, 5)
    }
    if(propName === 'content'){
      this.pages[pageIdx].layers[layerIdx][propName] = String(propValue)
    }else if(propName && propName.includes('textShadow')){
      const [key] = propName.split('|')
      this.pages[pageIdx].layers[layerIdx].textShadow[key] = propValue
      this.textShadowUpdate = propValue
    }else{
      this.pages[pageIdx].layers[layerIdx][propName] = propValue  
    }
    this.setChanged(true)
    //this.resizeTextLayer(layerId)
    this.appendToHistory()
  }

  changeFilterProp(layerId, propName, propValue){
    this.pages.forEach(page => {
      page.layers.forEach(layer => {
        if(layer.id === layerId){
          if(!layer.filters){
            layer.filters = {
              opacity: 100,
              brightness: 100,
              contrast: 100,
              saturation: 100,
              blur: 0
            }
          }
          const filters = {...layer.filters}
          filters[propName] = propValue
          layer.filters = filters
          this.setChanged(true)
        }
      })
    })
  }

  appendFonts(){
    const textLayers = this.getAllLayers().filter(({ type }) => type === 'text')
    try{
      textLayers.forEach(text => {
        if(text.font.id !== 'arial'){
          this.appendFont(text.font)
        }
      })
    }catch(err){
      console.log(err)
    }
  }

  changePagesColor(color, transparent = false){
    this.pages.forEach(p => {
      p.transparent = transparent
      if(transparent){
        return
      }
      p.background = color
    })
    this.setChanged(true)
    this.appendToHistory()
  }

  changeTextWeight(layerId, bold){
    const weight = bold ? 700 : 400
    const {pageIdx, layerIdx} = this.findLayerIdx(layerId)
    this.pages[pageIdx].layers[layerIdx].weight = weight
    this.setChanged(true)
  }

  deleteLayerFromGroup(layerId){
    const affectedGroups = []
    this.groups.forEach(group => {
      if(group.layers.includes(layerId)){
        group.layers = group.layers.filter(id => id !== layerId)
        affectedGroups.push(group.id)
      }
    })
    const layers = this.getAllLayers()
    layers.forEach(layer => {
      if(layer.type === 'group' && affectedGroups.includes(layer.id)){
        const groupLayers = layers.filter(({ id }) => layer.layers.includes(id) && id !== layerId)
        const ids = groupLayers.map(l => l.id)
        layer.layers = ids
        this.resizeGroupByLayers(layer.id)
      }
    })
    this.setChanged(true)
  }

  deleteLayerFromPage(layerIndex, page = 0) {
    if(layerIndex) {
      const layer = this.pages[page].layers[layerIndex]
      const type = layer.type
      const layerId = layer.id
      this.pages[page].layers = [
          ...this.pages[page].layers.slice(0, layerIndex),
          ...this.pages[page].layers.slice(layerIndex + 1, this.pages[page].layers.length),
      ]
      if(type === 'text'){
        this.textStyleToolbars = this.textStyleToolbars.filter(({ id }) => id !== layerId)
      }
    }
    this.setChanged(true)
  }

  getPageByLayerId(layerId){
    let idx = 0
    this.pages.forEach((page, index) => {
      const ids = page.layers.map(l => l.id)
      if(ids.includes(layerId)){
        idx = index
      }
    })
    return {
      idx,
      page: this.pages[idx]
    }
  }

  deleteLayerById(id, keepLayers = false) {
    this.editingColor = null
    if(id){
      const { idx: pageIdx } = this.getPageByLayerId(id)
      const idx = this.pages[pageIdx].layers.findIndex(({ id: layerId }) => layerId === id)
      if(idx === -1){
        return
      }
      const type = this.pages[pageIdx].layers[idx].type
      if(type === 'group' && !keepLayers){
        const ids = this.pages[pageIdx].layers[idx].layers
        this.pages[pageIdx].layers = this.pages[pageIdx].layers.filter(l => !ids.includes(l.id))
      }
      this.pages[pageIdx].layers = this.pages[pageIdx].layers.filter(f => f.id !== id);
      this.selectedLayer = null;
      if(type === 'text'){
        this.editingTextId = null
        this.textStyleToolbars = this.textStyleToolbars.filter(bar => bar.id !== id)
        this.deleteLayerFromGroup(id)
      }
      this.setChanged(true)
      this.appendToHistory()
    }
  }

  hideUpload(){
    const uploadArea = document.querySelector('.hidden-upload')
    if(uploadArea){
      uploadArea.style.display = 'none'
    }
  }

  appendToHistory() {
    this.hideUpload()
    historyStore.appendToHistory(this.pages)
  }

  undo() {
    if(this.editingTextId || this.editingColor){
      return
    }
    this.checkAndCloseCropper()
    const newState = historyStore.undo()
    const layerIds = this.getAllLayers().map(l => l.id)
    const newIds = []
    const newLayers = []
    if(!newState){
      return
    }
    newState.forEach(page => {
      page.active = false
      const ids = page.layers.map(l => {
        if(l.selected){
          this.selectedLayer = l.id
          if(l.type === 'svgGroup' && !this.editingColor && l.assetColors && l.assetColors.length){
            this.editingColor = l.assetColors[0].color
          }
        }
        return l.id
      })
      newIds.push(...ids)
      newLayers.push(...page.layers)
    })
    const deletedLayer = newIds.find(layerId => !layerIds.includes(layerId))
    if(deletedLayer){
      const layer = newLayers.find(({ id }) => id === deletedLayer)
      if(layer && layer.type === 'text'){
        const toolbar = new TextStyleToolbar(layer.id)
        this.textStyleToolbars.push(toolbar)
      }
    }
    this.activePage = null
    this.pages = newState
    this.setChanged(true)
  }

  redo() {
    if(this.editingColor || this.editingTextId){
      return
    }
    this.checkAndCloseCropper()
    const newState = historyStore.redo()
    if(!newState){
      return
    }
    newState.forEach(page => {
      page.active = false
      page.layers.forEach(l => {
        if(l.selected){
          this.selectLayer(l.id)
          if(l.type === 'svgGroup' && !this.editingColor && l.assetColors && l.assetColors.length){
            this.editingColor = l.assetColors[0].color
          }
        }
      })
    })
    this.activePage = null
    this.pages = newState
    this.setChanged(true)
  }

  setTextLayerSize(newSize, id){
    const {pageIdx, layerIdx} = this.findLayerIdx(id)
    this.pages[pageIdx].layers[layerIdx].size = newSize
  }

  getSelectedLayer(){
    if(!this.selectedLayer){
      return null
    }
    const layers = []
    this.pages.forEach(p => {
      p.layers.forEach(l => layers.push(l))
    })
    const layer = layers.filter(({ selected }) => selected)
    return layer[0]
  }

  getAllLayers(){
    const layers = []
    this.pages.forEach(page => {
      page.layers.forEach(layer => layers.push(layer))
    })
    return layers
  }

  groupAllOnPage(){
    let page = this.activePage
    if(!this.activePage && !this.selectedLayer){
      return
    }
    if(this.selectedLayer && !this.activePage){
      const { pageIdx } = this.findLayerIdx(this.selectedLayer)
      page = this.pages[pageIdx].id
    }
    if(this.pageGrouped){
      this.clearExistingGroup()
      return
    }
    let layers
    if(page){
      layers = this.pages.find(({ id }) => id === page).layers.map(l => l.id)
    }
    if(this.selectedLayer){
      const { pageIdx } = this.findLayerIdx(this.selectedLayer)
      layers = this.pages[pageIdx].layers.map(l => l.id)
    }      
    if(layers.length === 0){
      return
    }
    this.groupLayersById(layers)
    this.pageGrouped = true
  }


  addToGroup(targetGroupId, layerId){
    const layers = this.getAllLayers()
    const layer = layers.find(({ id }) => id === layerId)
    const targetGroup = this.groups.find(({ id }) => id === targetGroupId)
    const targetGroupLayer = layers.find(({ id }) => id === targetGroupId)
    if(!layer || !targetGroupLayer || !targetGroup){
      return
    }
    if(layer.type === 'group'){
      const { pageIdx, layerIdx } = this.findLayerIdx(layerId)
      targetGroup.layers.push(...layer.layers)
      targetGroupLayer.layers.push(...layer.layers)
      const targetLayers = layers.filter(({ id }) => layer.layers.includes(id))
      targetLayers.forEach(l => {
        if(l.groupId && !targetGroup.finalGroup){
          l.groupId = null
        }
        if(targetGroup.finalGroup){
          l.groupId = targetGroup.id
        }
      })
      this.pages[pageIdx].layers.splice(layerIdx, 1)
      setTimeout(() => {
        this.resizeGroupByLayers(targetGroupId)
      }, 10)
    }else{
      if(!targetGroupLayer.layers.includes(layerId)){
        targetGroup.layers.push(layerId)
        targetGroupLayer.layers.push(layerId)
        if(targetGroup.finalGroup){
          layer.groupId = targetGroupId
        }
        this.resizeGroupByLayers(targetGroupId)
      }
    }
    const unique = []
    targetGroup.layers.forEach(id => {
      if(!unique.includes(id)){
        unique.push(id)
      }
    })
    targetGroup.layers = unique
    targetGroupLayer.layers = unique
    this.appendToHistory()
  }

  groupLayersById(layerIds){
    const allLayers = this.getAllLayers()
    const layers = []
    let groupId
    const groupedLayerIds = []
    const groupsToRemove = []
    const finalGroups = []
    if(layerIds.length === 0){
      return
    }
    if(layerIds.length === 1){
      const l = allLayers.find(({ id }) => id === layerIds[0])
      if(l.locked){
        return
      }
      this.selectLayer(layerIds[0])
      return
    }
    let pageIndex
    allLayers.forEach(layer => {
      if(layerIds.includes(layer.id) && layer.type === 'group' && layer.finalGroup && !layer.locked){
        groupedLayerIds.push(...layer.layers)
        groupsToRemove.push(layer.id)
        const { idx } = this.getPageByLayerId(layer.id)
        finalGroups.push({...layer, pageNumber: idx})
      }
    })
    if(finalGroups.length > 0){
      this.groupedGroups = finalGroups
    }
    this.groups = this.groups.filter(({ id }) => !groupsToRemove.includes(id))
    groupsToRemove.forEach(groupId => {
      const { pageIdx } = this.findLayerIdx(groupId)
      const targetLayers = this.pages[pageIdx].layers
      this.pages[pageIdx].layers = targetLayers.filter(({ id }) => !groupsToRemove.includes(id))
    })
    allLayers.forEach(layer => {
      if((layerIds.includes(layer.id) || groupedLayerIds.includes(layer.id)) && layer.type !== 'group' && !layer.locked){
        layers.push(layer)
        const { pageIdx } = this.findLayerIdx(layer.id)
        pageIndex = pageIdx
      }
      if(groupedLayerIds.includes(layer.id) && layer.groupId){
        layer.groupId = null
      }
    })
    const { xPos, yPos, groupHeight, groupWidth } = this.calculateGroupDimensions(layers)
    const ids = layers.map(l => l.id)
    groupId = uuidv4()
    const group = new LayerGroup(
      groupId,
      groupHeight,
      groupWidth,
      groupHeight,
      groupWidth,
      groupHeight,
      groupWidth,
      groupWidth,
      groupHeight,
      xPos,
      yPos,
      0,
      0,
      this.scale,
      0,
      ids,
      false,
      false,
      null,
      true
    )
    if(isNaN(pageIndex)){
      return
    }
    this.pages[pageIndex].layers.push(group)
    this.groups.push(group)
    this.pages[pageIndex].layers.forEach(l => {
      l.selected = false
    })
    this.selectLayer(groupId)
    this.setChanged(true)
    this.appendToHistory()
    return groupId
  }

  cutLayerFromPage(){
    if(!this.selectedLayer){
      return
    }
    const { pageIdx, layerIdx } = this.findLayerIdx(this.selectedLayer)
    this.cutLayer = this.pages[pageIdx].layers[layerIdx]
    this.cutIndex = pageIdx
    if(this.cutLayer.type === 'group'){
      this.groups = this.groups.filter(({ id }) => id !== this.cutLayer.id)
      const layers = this.getAllLayers()
      this.cutGroupLayers = layers.filter(({ id }) => this.cutLayer.layers.includes(id))
      this.pages[pageIdx].layers = this.pages[pageIdx].layers.filter(({ id }) => !this.cutLayer.layers.includes(id))
    }
    this.pages[pageIdx].layers = this.pages[pageIdx].layers.filter(l => l.id !== this.selectedLayer)
    this.selectedLayer = null
  }

  clearExistingGroup(clearId = null){
    const layer = this.getSelectedLayer()
    let group = this.groups.find(({ finalGroup }) => !finalGroup)
    if(clearId){
      group = this.groups.find(({ id: gid }) => gid === clearId)
    }
    if(layer && layer.type === 'group' && !layer.finalGroup){
      group = layer
    }
    if(group && group.locked){
      return
    }
    this.pageGrouped = false
    if(!group){
      return
    }
    if(this.groupedGroups){
      this.groupedGroups.forEach(oldGroup => {
        let mutated = false
        oldGroup.layers.forEach(layerId => {
          if(group.layers.includes(layerId) && !mutated){
            const groupLayers = this.getAllLayers().filter(({ id }) => oldGroup.layers.includes(id))
            const { groupHeight, groupWidth, xPos, yPos } = this.calculateGroupDimensions(groupLayers)
            oldGroup.height = groupHeight
            oldGroup.width = groupWidth
            oldGroup.xPos = xPos
            oldGroup.yPos = yPos
            oldGroup.displayHeight = groupHeight
            oldGroup.displayWidth = groupWidth
            oldGroup.originalDisplayHeight = groupHeight
            oldGroup.originalDisplayWidth = groupWidth
            oldGroup.frameHeight = groupHeight
            oldGroup.frameWidth = groupWidth
            const page = oldGroup.pageNumber
            delete oldGroup.pageNumber
            this.groups.push(oldGroup)
            this.pages[page].layers.push(oldGroup)
            mutated = true
          }
        })
      })
      this.groupedGroups = null
    }
    this.groups = this.groups.filter(({ id }) => id !== group.id)
    this.setChanged(true)
    this.deleteLayerById(group.id, true)
  }

  setPageCenter(zoomOut = false, override = false){
    const el = document.querySelector('.container-fluid.d-flex')
    const warea = document.querySelector('.workarea')
    if(el && warea){
      const scrollWidth = el.scrollWidth
      if(document.body.clientWidth < scrollWidth){
        let offset = ((scrollWidth - document.body.clientWidth) / 2)
        if(Math.floor(el.scrollLeft) !== Math.floor(this.pageCenter) && !override){
          return
        }
        el.scroll(offset, 0)
        this.pageCenter = offset
      }else{
        this.pageCenter = 0
      }
    }
  }

  updateZoom(zoom) {
    const zoomOut = this.zoom > zoom
    this.zoom = zoom
    this.setPageCenter(zoomOut)
  }

  unsetActivePage(){
    this.pages.forEach(p => {
      p.active = false
    })
    this.activePage = null
    this.setChanged(true, false)
  }

  setActivePage(pageId){
    const pageIdx = this.pages.findIndex(({ id }) => id === pageId)
    this.pages.forEach(p => {
      p.active = false
    })
    if(pageIdx === -1){
      return
    }
    this.activePage = this.pages[pageIdx].id
    this.pages[pageIdx].active = true
    this.setChanged(true, false)
  }

  getActivePage(){
    if(!this.activePage){
      return null
    }
    return this.pages.find(({ id }) => id === this.activePage)
  }

  getLayer(layerId){
    const layers = this.getAllLayers()
    return layers.find(({ id }) => id === layerId)
  }

  getPage(pageId){
    return this.pages.find(({ id }) => id === pageId)
  }

  scalePageLayers(page, w, h){
    const p = { width: w, height: h, displayHeight: h, displayWidth: w }
    const xRatio = page.displayWidth / w
    const yRatio = page.displayHeight / h
    const xLarger = page.displayHeight < w
    const yLarger = page.displayHeight < h
    let scaleRatio = yRatio
    if (xRatio > yRatio) {
      scaleRatio = xRatio
    }
    const groupIds = []
    for (const layer of page.layers) {
      if(layer.type === 'group'){
        groupIds.push(layer.id)
      }else{
        if(scaleRatio < 1){
          scaleRatio = xRatio > yRatio ? yRatio : xRatio
        }
        const aspectW = layer.displayWidth / w
        const aspectH = layer.displayHeight / h
        layer.displayWidth /= scaleRatio
        layer.displayHeight /= scaleRatio
        layer.frameWidth /= scaleRatio
        layer.frameHeight /= scaleRatio
        layer.originalDisplayWidth /= scaleRatio
        layer.originalDisplayHeight /= scaleRatio
        const pageCenterX = w / 2
        const pageCenterY = h / 2
        const layerCenterX = layer.displayWidth / 2
        const layerCenterY = layer.displayHeight / 2
        let xNew = (pageCenterX + (aspectW > aspectH ? aspectW : aspectH) * (layerCenterX - pageCenterX)) / 2
        if(!xLarger || !yLarger){
          xNew = (pageCenterX + (aspectW > aspectH ? aspectW : aspectH) / (layerCenterX - pageCenterX)) / 2
        }
        let yNew = (pageCenterY + (aspectH > aspectW ? aspectH : aspectW) * (layerCenterY - pageCenterY)) / 2
        if(!yLarger || !xLarger){
          yNew = (pageCenterY + (aspectH > aspectW ? aspectH : aspectW) / (layerCenterY - pageCenterY)) / 2
        }
        layer.xPos = xNew
        layer.yPos = yNew
        if(xRatio < 1){
          layer.yPos *= scaleRatio
          layer.xCrop *= scaleRatio
          layer.yCrop *= scaleRatio
        }else{
          layer.yPos /= xRatio < yRatio ? yRatio : xRatio
          layer.xCrop /= xRatio < yRatio ? yRatio : xRatio
          layer.yCrop /= yRatio < xRatio ? xRatio : yRatio
        }
        if (layer.editorWidth && layer.editorHeight) {
          layer.editorWidth /= scaleRatio
          layer.editorHeight /= scaleRatio
          layer.size /= scaleRatio
        }
        if(layer.type === 'text'){
          this.resizeTextLayer(layer.id)
        }
        layer.scale = scaleRatio
      }
    }
    return { p, groupIds }
  }

  updatePage(w, h, sidebaropen = false) {
    this.checkAndCloseCropper()
    const workareaDom = document.querySelector('.workarea__canvas-wrapper')
    this.setWorkAreaSize(workareaDom.clientHeight, workareaDom.clientWidth)
    const scaleGroups = []
    for (const page of this.pages) {
      const { p: obj, groupIds } = this.scalePageLayers(page, w, h, sidebaropen)
      scaleGroups.push(...groupIds)
      const pageInd = this.pages.findIndex(({ id }) => id === page.id)
      if (pageInd === -1) return
      const newPage = { ...this.pages[pageInd], ...obj }
      this.pages = [
        ...this.pages.slice(0, pageInd),
        newPage,
        ...this.pages.slice(pageInd + 1, this.pages.length)
      ];
    }
    const p = this.pages[0]
    this.calculateZoomForScreen()
    //Wait for changes on page to migrate and render in the dom
    setTimeout(() => {
      scaleGroups.forEach(groupId => {
        this.resizeGroupByLayers(groupId)
      })
    }, 10)
    this.setActivePage(p.id)
    this.appendToHistory()
    this.setChanged(true, true)
    setTimeout(() => {
      this.unsetActivePage()
      document.querySelector('.full-workarea').style.width = '100%'
      this.pages.forEach((p, pageIdx) => {
        if(pageIdx > -1){
          this.pages[pageIdx].backgroundId = p.backgroundId
          this.setPageBackgroundSize(p.id, p.backgroundUrl)
        }
      })
    }, 1)
  }

  setWorkAreaSize(height, width) {
    this.workAreaSize = {
      w: width,
      h: height
    }
  }
}

export default WorkAreaStore